import React, { useState, useEffect, useRef } from "react";
// import "../feedbackList/feedbackListForAdmin.scss";
import {
    Button,
    Card,
    Modal,
    OverlayTrigger,
    Spinner,
    Table,
    Tooltip,
} from "react-bootstrap";
import './subscription.scss'
import ServiceRequestDetails from "../serviceRequestDetails/serviceRequestDetails";
import CallDetails from "../callDetails/callDetails";
import AddUserByAdmin from "../addUserByAdmin/addUserByAdmin";
// import FeedbackDetailsForAdmin from "./feedbackDetailsForAdmin";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { allFeedbackList } from "../../service/api/user/allFeedbackList";
import deleteFeedbackApi from "../../service/api/user/deleteFeedbackById";
import AcceptRejectModal from "../../jsx/components/modalAcceptReject/modalAcceptreject";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import { getFeedbackById } from "../../service/api/user/getFeedbackById";
import PaginationAndSearching from "../../component/paginationAndSearching/paginationAndSearching";
import SkeletonTableRow from "../../component/skeletonTableRow/skeletonTableRow";
import InternationalPhoneFormat from "../../ui/InternationalPhoneFormat";
import { lblEmail, lblPhoneNumber, txtAction, txtCreatedDate, txtFeedbackList, txtFullName, txtNoRecordsFound, txtRole } from "../../dataBaseFile/label";
import { callRequests } from "../../service/api/callHistory/callRequests";
import { getProductsList } from "../../service/api/paymentGateway/getProductsList";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import Cards from 'react-credit-cards';
import creditCardType from 'credit-card-type';
import { createPaymentMethod } from "../../service/api/paymentGateway/createPaymentMethod";
import { userById } from "../../service/api/user/userById";
import { setUserDetails } from "../../feature/userData/userData";
import setDefaultPaymentMethodById from "../../service/api/paymentGateway/setDefaultPaymentMethodById";
import { getPaymentMethodListByCustomerId } from "../../service/api/paymentGateway/getPaymentMethodListByCustomerId";
import InputField from "../../jsx/components/fields/inputField";
import ResponceForAPI from "../../component/backDrop/responcesForAPI";
import UpdateCardDetails from "../paymentModule/updateCardDetails";
import AddNewCard from "../paymentModule/addNewCard";
import { createSubscription } from "../../service/api/paymentGateway/createSubscription";
import { getSubscriptionStatusById } from "../../service/api/paymentGateway/getSubscriptionStatusById";
import cancelSubscriptionById from "../../service/api/paymentGateway/cancelSubscriptionById";
import updateSubscriptionById from "../../service/api/paymentGateway/updateSubscriptionById";
import { chargeProfessionalById } from "../../service/api/paymentGateway/chargeProfessionalById";
import SkeletonDivElement from "../../component/skeletonTableRow/skeletonDivElement";
import TextArea from "../../jsx/components/fields/textArea";
import Select from "react-select";
import { checkPromoCode } from "../../service/api/paymentGateway/checkPromoCode";
import { getPaymentMethodSupportedList } from "../../service/api/paymentGateway/getPaymentMethodSupportedList";

import { Elements, CardElement, useStripe, useElements, CardNumberElement } from '@stripe/react-stripe-js';
import { CardNumberInput, CardExpiryInput, CardCvcInput } from '../paymentModule/cardElements/cardInput';
import axios from "axios";
import StandardInputField from "../../jsx/components/fields/standardInputField";
import { isPostalCode } from "validator";
import UserAddOwnCompany from "../companies/userAddOwnCompany";
import { getPricePerQuantityApi } from "../../service/api/paymentGateway/getPricePerQuantity";

const Subscription = () => {
    const {
        role,
        paymentMethodID,
        customerID,
        subscriptionId,
        subscriptionPaidStatus,
        upcomingSubscriptionStatus,
        isUpcomingPlanFlag,
        upcomingPlanProductId,
        upcomingPlanStartDate,
        impersonateFlag,
        freeTrialProductId,
        freeTrialPrevSubscriptionId,
        activeSubscriptionEndTime,
        freeTrialStatus,
        isFreeTrialSubscription,
        companyId,
        userName,
        userLastName,
        emailRedux,
        phoneCodeRedux,
        phoneNumberRedux,
        billingCycleAnchorDate,
        subscriptionProductAmont,
        subscriptionLicenseQuantity,
        paidProductId,
        subscriptionType,
        remainingVideoInvitationCount,
        totalMonthlyFreeVideoLinkCount,
    } = useSelector((state) => state.user);

    const [basicModal, setBasicModal] = useState(false);
    const [initiColor, setInitiColor] = useState(true);
    const [sortingCol, setSortingCol] = useState(true);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [skeltonVal, setSkeltonVal] = useState(false);
    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPage, setTotalPage] = useState(1);
    const [elements, setElements] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);

    const [sortByValue, setSortByValue] = useState("DESC");
    const [columnName, setColumnName] = useState("created_date_dtm");
    const [searchValue, setSearchValue] = useState("");
    const [totalNoRecord, setTotalNoRecord] = useState(100);
    const [flag, setFlag] = useState(false);
    const [dataToModal, setDataToModal] = useState(false);

    const [individualSubObj, setIndividualSubObj] = useState({});
    const [currentProductId, setCurrentProductId] = useState("");   // for the individual product of subscription purchased
    const [currentPeriodEndTime, setCurrentPeriodEndTime] = useState("");
    const [currentProductPrice, setCurrentProductPrice] = useState(0);
    const [primaryCardLoading, setPrimaryCardLoading] = useState(false);
    const [isPaymentMethodErr, setIsPaymentMethodErr] = useState(false);
    const [myCountryCode, setMyCountryCode] = useState('US');

    const [isAddingLicenses, setIsAddingLicenses] = useState(false);

    useEffect(() => {
        setCurrentProductId(paidProductId ? paidProductId : "");
        setCurrentPeriodEndTime(activeSubscriptionEndTime ? activeSubscriptionEndTime : 0);
        setCurrentProductPrice(subscriptionProductAmont ? (subscriptionProductAmont / 100) : 0);
        setMySubscriptionStatus(subscriptionPaidStatus)
        setNumberOfLicenses(subscriptionLicenseQuantity || 1);
    }, [paidProductId, activeSubscriptionEndTime, subscriptionProductAmont, subscriptionPaidStatus, subscriptionLicenseQuantity])

    // console.log("individualSubObj", individualSubObj)

    console.log(currentProductId, "currentProductId")


    const [customeSkeletonLoadingSubscription, setCustomeSkeletonLoadingSubscription] = useState(false);
    const [customeSkeletonLoadingProducts, setCustomeSkeletonLoadingProducts] = useState(false);

    const [updateSubscriptionState, setUpdateSubscriptionState] = useState(false);
    const [checkForGetSubscritptionStatus, setCheckForGetSubscritptionStatus] = useState(true);

    const [toggleCardsMenu, setToggleCardsMenu] = useState(false);

    const [numberOfLicenseLimit, setNumberOfLicenseLimit] = useState(1);
    const [numberOfLicenses, setNumberOfLicenses] = useState(subscriptionLicenseQuantity || 1);
    const [licensePriceLoading, setLicensePriceLoading] = useState(false);
    const [priceAfterLicenses, setPriceAfterLicenses] = useState(0);

    const rows = elements;

    useEffect(() => {
        if (numberOfLicenses) {
            handleGetPricePerQuantityApi();
        }
    }, [numberOfLicenses])

    const timeoutRef = useRef(null);
    const handleNumberOfLicenses = (e) => {
        // setNumberOfLicenses(e.target.value.replace(/\D/g, ''));

        const newValue = e.target.value;

        // Allow numeric input or empty string
        if (/^\d*$/.test(newValue)) {
            // Only set the value if it is less than or equal to 1000
            if (newValue === "" || parseInt(newValue, 10) <= numberOfLicenseLimit) {
                setNumberOfLicenses(newValue);
            }

            // Clear any existing timeout
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            // If the input is empty, set the value back to "1" after a short delay
            timeoutRef.current = setTimeout(() => {
                if (newValue === "" || parseInt(newValue, 10) <= subscriptionLicenseQuantity) {
                    setNumberOfLicenses(subscriptionLicenseQuantity || "1");
                }
            }, 1000);
        }
    }


    const handleGetPricePerQuantityApi = () => {
        setLicensePriceLoading(true);
        let details = {
            quantity: numberOfLicenses
        }
        dispatch(
            getPricePerQuantityApi(details, (res) => {
                setLicensePriceLoading(false);
                // console.log(res?.data?.data?.cost_in_cents, "res?.data?.cost_in_cents");
                setPriceAfterLicenses(res?.data?.data?.cost_in_cents);
                setNumberOfLicenseLimit(res?.data?.data?.max_licence_limit)
            }, (err) => {
                setLicensePriceLoading(false);
            })
        )
    }

    function getProducts() {
        setSkeltonVal(true);
        setCustomeSkeletonLoadingProducts(true);

        let details = {};
        dispatch(
            getProductsList(details, (res) => {
                // console.log(res.data.data);

                // console.log(res.total_count)

                setElements(res.data.data);
                // if (!subscriptionId) {
                //     setCustomeSkeletonLoadingProducts(false);
                // }
                setCustomeSkeletonLoadingProducts(false);

                // setTotalNoRecord(res.total_count);

            }, (err) => {
                console.log(err);
                setCustomeSkeletonLoadingProducts(false);
            })
        )
    }



    const tooltipCopyTxt = (
        <Tooltip id="tooltip">
            <strong>Copy to clipboard</strong>
        </Tooltip>
    );

    // Here all Payment module integration

    const [paymentModal, setPaymentModal] = useState(false);
    const [cardInfo, setCardInfo] = useState({
        cardNumber: '',
        expiryDate: '',
        cvc: '',
        cardHolder: '',
        focus: '',
    });
    const [isCardHolderNameErr, setIsCardHolderNameErr] = useState(false);
    const [isCardNumberErr, setIsCardNumberErr] = useState(false);
    const [isCardExpErr, setIsCardExpErr] = useState(false);
    const [isCardCVCErr, setIsCardCVCErr] = useState(false);

    const [responceMsg, setResponceMsg] = useState("");
    const [toasterType, setToasterType] = useState('');
    const [handleToaster, setHandleToaster] = useState(false);
    const [apiResponce, setApiResponse] = useState(false);

    const [formatedNumber, setFormatedNumber] = useState("");

    const handleCardNumberChange = (e) => {
        setIsCardNumberErr(false);
        // Remove anything that's not a digit
        const newValue = e.target.value.replace(/\D/g, '');

        // Add spaces after every 4 digits for display
        const formattedValue = newValue.replace(/(\d{4})/g, '$1 ').trim();

        // Update the actual input value
        e.target.value = formattedValue;

        setFormatedNumber(formattedValue)

        // Update state without spaces
        setCardInfo({
            ...cardInfo,
            cardNumber: newValue
        });
    };

    const handleExpiryDateChange = (e) => {
        setIsCardExpErr(false);
        let value = e.target.value.replace(/\D/g, '');
        if (value.length > 4) value = value.substr(0, 4); // Maximum length of 4 digits
        if (value.length > 2) value = value.substr(0, 2) + '/' + value.substr(2); // Insert slash after two digits

        setCardInfo({
            ...cardInfo,
            expiryDate: value
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === 'cardHolder') {
            setIsCardHolderNameErr(false)
        }

        setCardInfo({
            ...cardInfo,
            [name]: value
        });
    };

    const handleCVCChange = (e) => {
        setIsCardCVCErr(false)
        const newValue = e.target.value.replace(/\D/g, ''); // Remove non-digit characters
        setCardInfo({
            ...cardInfo,
            cvc: newValue
        });
    };

    const handleInputFocus = (e) => {
        const { name } = e.target;
        setCardInfo({
            ...cardInfo,
            focus: name
        });
    };

    const handleCardHolderNameBlurCheck = () => {
        if (cardInfo.cardHolder.trim() === '') {
            setIsCardHolderNameErr(true);
        }
    }

    const handleCardNumberBlurCheck = () => {
        // console.log(!validateCardNumber(Number(cardInfo.cardNumber)))
        // console.log(cardInfo.cardNumber, typeof cardInfo.cardNumber, 'handleCardNumberBlurCheck')

        const cardType = creditCardType(cardInfo.cardNumber);
        // console.log(cardType, 'cardType')

        if (cardInfo.cardNumber.length !== 16 || cardType.length === 0
            // || !validator.isCreditCard(cardInfo.cardNumber)
        ) {
            setIsCardNumberErr(true);
        }
    }

    const handleCardExpBlurCheck = () => {
        const [month, year] = cardInfo.expiryDate.split('/');
        if (cardInfo.expiryDate.trim() === ""
            || cardInfo.expiryDate.trim().length != 5
            || Number(month) > 12
            || Number(year) < Number((new Date()).getFullYear().toString().slice(-2))) {
            setIsCardExpErr(true);
        }
    }

    const handleCardCVCBlurCheck = () => {
        if (cardInfo.cvc.length < 3 || cardInfo.cvc.trim() === "") {
            setIsCardCVCErr(true);
        }
    }


    function handleGetUserById() {
        let details = {
            user_id_ids: localStorage.getItem('user_id'),
            role_id_int: localStorage.getItem("roleId"),
            user_impersonate_flag: 0
        }
        dispatch(
            userById(details, (res) => {
                dispatch(setUserDetails(res.data.data))
            }),
        )
    }
    const handleSubmitPay = (e) => {
        e.preventDefault();
        setApiResponse(true);
        const [month, year] = cardInfo.expiryDate.split('/');
        if (cardInfo.cardHolder.trim() === '') {
            setIsCardHolderNameErr(true);
            setApiResponse(false);
        }
        const cardType = creditCardType(cardInfo.cardNumber);

        if (cardInfo.cardNumber.length !== 16 || cardType.length === 0
            // || !validator.isCreditCard(cardInfo.cardNumber)
        ) {
            setIsCardNumberErr(true);
        }
        if (cardInfo.expiryDate.trim() === ""
            || Number(month) > 12
            || Number(year) < Number((new Date()).getFullYear().toString().slice(-2))) {
            setIsCardExpErr(true);
            setApiResponse(false);
        }
        if (cardInfo.cvc.length < 3 || cardInfo.cvc.trim() === "") {
            setIsCardCVCErr(true);
            setApiResponse(false);
        }

        if ((cardInfo.cardHolder.trim() === '') ||
            (cardInfo.cardNumber.length !== 16) ||
            (cardType.length === 0) ||
            //  !validator.isCreditCard(cardInfo.cardNumber) ||
            (cardInfo.expiryDate.trim() === ""
                || cardInfo.expiryDate.trim().length != 5
                || Number(month) > 12
                || Number(year) < Number((new Date()).getFullYear().toString().slice(-2))) ||
            (cardInfo.cvc.length < 3 || cardInfo.cvc.trim() === "")) {
            setApiResponse(false);
            return
        }

        if (!isCardHolderNameErr && !isCardNumberErr && !isCardExpErr && !isCardCVCErr) {
            // Here you can handle the submission of the credit card information.
            // You would typically send this to a server that can process the payment using a third-party payment processor.

            let details = new FormData();

            details.append("user_id_ids", localStorage.getItem("user_id"));
            details.append("name_on_card", cardInfo.cardHolder);
            details.append("card_number", parseInt(cardInfo.cardNumber));
            details.append("expiry_month", parseInt(month));
            details.append("expiry_year", parseInt(year));
            details.append("card_cvc_number", parseInt(cardInfo.cvc));
            details.append("token_chr", "tok_visa");

            dispatch(
                createPaymentMethod(
                    details,
                    (res) => {
                        // console.log(res)
                        setApiResponse(false);
                        setPaymentModal(false);
                        setResponceMsg(res.data.message)
                        setToasterType("success")

                        handleGetUserById()
                        // submitFeedback();
                        // if (updateSubscriptionState) {
                        //     updateSubscriptionFn()
                        // } else {
                        //     createSubscriptionFn();
                        // }

                        updateSubscriptionFn();


                        // setHandleToaster(true);
                        // setTimeout(() => {
                        //     setHandleToaster(false);
                        // }, 11000);
                    },
                    (res) => {
                        // console.log(res)
                        setResponceMsg(res.data.message)
                        setToasterType("error");

                        setApiResponse(false);
                        setPaymentModal(false);

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    }
                )
            )


        }

    };

    const handleConfirmPay = () => {
        setPaymentModal(false);

        // old code
        // if (updateSubscriptionState) {
        //     updateSubscriptionFn()
        // } else {
        //     createSubscriptionFn();
        // }
        // submitFeedback();

        // new code
        updateSubscriptionFn();
    }


    // Handle Update credit card details 

    const [cardArr, setCardArr] = useState([]);
    const [particularCard, setParticularCard] = useState({});

    const setInitialCardDetails = (res) => {

        setCardArr(res.data || []);

    }

    const [updateCardTrigger, setUpdateCardTrigger] = useState(false);
    const handleCloseUpdateCard = () => {
        setUpdateCardTrigger(false);
        getPaymentMethodList();
    }
    const handleOpenUpdateCard = (element, isPrimaryCard) => {
        setUpdateCardTrigger(true);
        if (isPrimaryCard) {
            setParticularCard(cardArr[cardArr.length - 1])
        } else {
            setParticularCard(element)
        }
    }

    // Add new card modal functions
    const [addNewCardTrigger, setAddNewCardTrigger] = useState(false);
    const handleCloseAddNewCard = () => {
        setAddNewCardTrigger(false);
        getPaymentMethodList();
        setPaymentConfirmModal(true);
    }
    const handleOpenAddNewCard = () => {
        setAddNewCardTrigger(true);
        // handleClosePaymentModalTrigger();
        setPaymentConfirmModal(false);
    }

    // Set default payment method
    const selectPrimaryCardFn = (e, element) => {
        e?.preventDefault();
        setPrimaryCardLoading(true);
        let details = new FormData();

        details.append("payment_method_id", element.id);
        details.append("user_id_ids", localStorage.getItem("user_id"));

        dispatch(
            setDefaultPaymentMethodById(
                details,
                (res) => {
                    // console.log(res)
                    setPrimaryCardLoading(false);
                    // setResponceMsg(res.data.message)
                    // setToasterType("success")

                    getPaymentMethodList();
                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                },
                (res) => {
                    // console.log(res)
                    setResponceMsg(res.data.message)
                    setToasterType("error");

                    setPrimaryCardLoading(false);

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }
            )
        )
    }

    // useEffect(() => {
    //     if (subscriptionId) {
    //         getSubscriptionStatusFn()
    //     }
    // }, [subscriptionId])

    useEffect(() => {
        getProducts();
    }, [subscriptionId, subscriptionPaidStatus, upcomingSubscriptionStatus])

    useEffect(() => {
        if (customerID) {
            getPaymentMethodList();
        }
    }, [])

    useEffect(() => {
        if (!customerID) {
            const getCountryCode = async () => {
                try {
                    const response = await axios.get('https://ipapi.co/json/');
                    const data = response.data;
                    console.log(`'My country code:', ${data.country}`)
                    setMyCountryCode(data.country);
                } catch (error) {
                    console.log('Error fetching country code:', error);
                }
            };
            getCountryCode();
        }
    }, []);

    useEffect(() => {
        if (updateSubscriptionState) {
            getProducts();
        }
    }, [updateSubscriptionState])

    const getPaymentMethodList = (firstTimeID) => {
        let details = {
            customer_id_ids: customerID || firstTimeID,
        }
        dispatch(
            getPaymentMethodListByCustomerId(details,
                (res) => {
                    // console.log(res.data.data)
                    setInitialCardDetails(res?.data?.data)
                },
                (res) => {
                    // console.log(res.data.data)
                })
        )
    }




    // Here start the functions for the subcription Module

    const [mySubscriptionName, setMySubscriptionName] = useState("");
    const [mySubscritionInvoice, setMySubscritionInvoice] = useState("");
    const [mySubscriptionStatus, setMySubscriptionStatus] = useState('');

    const getSubscriptionStatusFn = (subId = '') => {
        setCustomeSkeletonLoadingSubscription(true);
        setCustomeSkeletonLoadingProducts(true);
        let details = {
            subscription_id_ids: subId || subscriptionId,
            role_id_ids: role
        }
        dispatch(
            getSubscriptionStatusById(details,
                (res) => {
                    // console.log(res.data.data, "subcription status")
                    // console.log(res?.data?.data.subscription_details?.latest_invoice?.lines.data[0].description, "subcription desciption")
                    // console.log(res?.data?.data.subscription_details?.latest_invoice?.invoice_pdf, "DOWNLOAD LINK")

                    setMySubscriptionName(res?.data?.data.subscription_details?.latest_invoice?.lines.data[0].description)
                    setMySubscritionInvoice(res?.data?.data.subscription_details?.latest_invoice?.invoice_pdf)
                    setMySubscriptionStatus(res?.data?.data?.subscription_status)

                    setCustomeSkeletonLoadingSubscription(false);
                    setCustomeSkeletonLoadingProducts(false);

                    setCurrentProductId(res?.data?.data?.subscription_details?.plan?.product || paidProductId);
                    setCurrentPeriodEndTime(res?.data?.data?.subscription_details?.current_period_end || activeSubscriptionEndTime);
                    setCurrentProductPrice((res?.data?.data?.subscription_details?.plan?.amount / 100) || (subscriptionProductAmont / 100));
                },
                (res) => {
                    // console.log(res.data.data, "subcription status")
                    setCustomeSkeletonLoadingSubscription(false);
                    setCustomeSkeletonLoadingProducts(false);
                })
        )
    }

    const handleClearCurrentSubDetails = () => {
        setMySubscriptionName('')
        setMySubscritionInvoice('')
        setMySubscriptionStatus('')


        setCurrentProductId('')
        setCurrentPeriodEndTime('');
        setCurrentProductPrice(0);
    }

    function convertUnixTime(unixTime) {
        // Create a new Date object from the Unix timestamp
        // Note: Unix timestamp should be in milliseconds for JavaScript Date object,
        // so we multiply by 1000 (because Unix timestamp is usually in seconds).
        const date = new Date(unixTime * 1000);

        // Define an array of month names to convert month number to month name
        const months = ["January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"];

        // Extract the day, month and year from the date
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();

        // Return the formatted date string
        return `${month} ${day}, ${year}`;
    }


    const [productId, setProductId] = useState("");
    const [subscriptionPrice, setSubscriptionPrice] = useState();

    const hanldeOpenPaymentModal = (element) => {
        handleCloseAddNewPaymentMethod();
        setPaymentModal(true);
        setProductId(element?.id);
        setSubscriptionPrice(element?.price_details.unit_amount / 100);
    }
    // console.log(subscriptionPrice, 'subscriptionPrice', productId, 'productId')

    // useEffect(() => {
    //     if (subscriptionId && checkForGetSubscritptionStatus && !isFreeTrialSubscription) {
    //         getSubscriptionStatusFn();
    //     }
    // }, [subscriptionId, checkForGetSubscritptionStatus, subscriptionPaidStatus, upcomingSubscriptionStatus])

    const createSubscriptionFn = () => {
        // e.preventDefault();
        setApiResponse(true);
        setCheckForGetSubscritptionStatus(false);

        console.log(productId, 'productId')


        // Condition for free subscription
        if (individualSubObj.id == "prod_free_trial_01") {
            if (!verifiedPromoCode) {
                setIsPromoCodeErr(true);
                setApiResponse(false);
                return;
            }
        }

        // Condition if paid subscritption and no promocode
        if (individualSubObj.id !== "prod_free_trial_01" && cardArr.length == 0 && !verifiedPromoCode) {

            setIsPaymentMethodErr(true);
            setApiResponse(false);
            return;
        }

        // Condition if paid subscritption and promocode with 100% discount
        if (individualSubObj.id !== "prod_free_trial_01" && cardArr.length == 0 && verifiedPromoCode && finalAmountAfterPromoCodeApplied != 0) {

            setIsPaymentMethodErr(true);
            setApiResponse(false);
            return;
        }


        let details = new FormData();

        details.append("user_id_ids", localStorage.getItem("user_id"));
        details.append("product_id_ids", productId);
        details.append("role_id_ids", role);
        verifiedPromoCode && details.append("promo_code_chr", verifiedPromoCode);
        individualSubObj?.is_company_plan_flag && details.append("quantity", numberOfLicenses);

        dispatch(
            createSubscription(
                details,
                (res) => {
                    console.log(res.data.data, "subbbbbbbbbbb")

                    setResponceMsg(res.data.message)
                    setToasterType("success")

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);

                    setCustomeSkeletonLoadingSubscription(true);

                    // handleGetUserById()

                    // chargeProfessionalFn();
                    if (individualSubObj.id == "prod_free_trial_01") {
                        getProducts();
                        setApiResponse(false);
                        handleClosePaymentModalTrigger();
                    }

                    if (verifiedPromoCode && finalAmountAfterPromoCodeApplied == 0) {
                        handleGetUserById();
                        getProducts();
                        setApiResponse(false);
                        handleClosePaymentModalTrigger();
                    }

                    if (individualSubObj.id !== "prod_free_trial_01" && cardArr.length !== 0) {
                        if (verifiedPromoCode && finalAmountAfterPromoCodeApplied != 0) {
                            let newData = {
                                subscription_id_ids: res?.data?.data?.subscription_details?.id,
                                user_id_ids: localStorage.getItem('user_id'),
                                role_id_ids: role,
                            }
                            dispatch(
                                chargeProfessionalById(newData,
                                    (res) => {
                                        // console.log(res.data.data, "subcription status")
                                        console.log(res)
                                        setCheckForGetSubscritptionStatus(true);
                                        handleGetUserById();

                                        setApiResponse(false);
                                        handleClosePaymentModalTrigger();
                                        getProducts();
                                    },
                                    (res) => {
                                        console.log(res)
                                        setCheckForGetSubscritptionStatus(true);
                                        setResponceMsg(res.data.message)
                                        setToasterType("error");

                                        setApiResponse(false);

                                        setHandleToaster(true);
                                        setTimeout(() => {
                                            setHandleToaster(false);
                                        }, 11000);
                                    })
                            )
                        }
                        if (!verifiedPromoCode) {
                            let newData = {
                                subscription_id_ids: res?.data?.data?.subscription_details?.id,
                                user_id_ids: localStorage.getItem('user_id'),
                                role_id_ids: role,
                            }
                            dispatch(
                                chargeProfessionalById(newData,
                                    (res) => {
                                        // console.log(res.data.data, "subcription status")
                                        console.log(res)
                                        setCheckForGetSubscritptionStatus(true);
                                        handleGetUserById();

                                        setApiResponse(false);
                                        handleClosePaymentModalTrigger();
                                        getProducts();
                                    },
                                    (res) => {
                                        console.log(res)
                                        setCheckForGetSubscritptionStatus(true);
                                        setResponceMsg(res.data.message)
                                        setToasterType("error");

                                        setApiResponse(false);

                                        setHandleToaster(true);
                                        setTimeout(() => {
                                            setHandleToaster(false);
                                        }, 11000);
                                    })
                            )
                        }

                    }
                },
                (res) => {
                    // console.log(res)
                    setResponceMsg(res.data.message)
                    setToasterType("error");

                    setApiResponse(false);

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }
            )
        )
    };

    // Cancel the subscription
    const cancelSubscriptionFn = () => {
        setApiResponse(true);

        let details = new FormData();

        // details.append("subscription_id_ids", subscriptionId || freeTrialPrevSubscriptionId || '');
        details.append("subscription_id_ids", subscriptionId || '');
        details.append("user_id_ids", localStorage.getItem('user_id'));
        details.append("role_id_ids", role);

        dispatch(
            cancelSubscriptionById(
                details,
                (res) => {
                    // console.log(res)
                    setApiResponse(false);
                    setResponceMsg(res.data.message)
                    setToasterType("success");
                    setCheckForGetSubscritptionStatus(true);

                    handleGetUserById();

                    handleCloseCancelSubModal();
                    handleCloseDowngradeToFreePlan();

                    // handleClearCurrentSubDetails();

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                },
                (res) => {
                    // console.log(res)
                    setResponceMsg(res.data.message)
                    setToasterType("error");

                    setApiResponse(false);

                    setCheckForGetSubscritptionStatus(true);

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }
            )
        )
    }

    // console.log(currentProductPrice, 'currentProductPrice');
    // Update the subcription


    const updateSubscriptionFn = () => {
        setApiResponse(true);

        console.log(productId, 'productId');

        if (individualSubObj.id == "prod_free_trial_01") {
            if (!verifiedPromoCode) {
                setIsPromoCodeErr(true);
                setApiResponse(false);
                return;
            }
        }

        if (individualSubObj.id !== "prod_free_trial_01" && cardArr.length == 0 && !verifiedPromoCode) {
            setIsPaymentMethodErr(true);
            setApiResponse(false);
            return;
        }

        // Condition if paid subscritption and promocode with 100% discount
        if (individualSubObj.id !== "prod_free_trial_01" && cardArr.length == 0 && verifiedPromoCode && finalAmountAfterPromoCodeApplied != 0) {

            setIsPaymentMethodErr(true);
            setApiResponse(false);
            return;
        }

        let details = new FormData();

        details.append("subscription_id_ids", subscriptionId || freeTrialPrevSubscriptionId || '');
        details.append("product_id_ids", productId);
        details.append("user_id_ids", localStorage.getItem('user_id'));
        details.append("role_id_ids", role);
        verifiedPromoCode && details.append("promo_code_chr", verifiedPromoCode);
        details.append("is_upgrade", (isFreeTrialSubscription && individualSubObj?.id == freeTrialProductId) ? 2 : isAddingLicenses ? 1 : currentProductPrice <= individualSubObj?.price_details?.unit_amount_in_dollars ? 1 : 0);
        individualSubObj?.is_company_plan_flag && details.append("quantity", numberOfLicenses);

        dispatch(
            updateSubscriptionById(
                details,
                (res) => {
                    // console.log(res)
                    setApiResponse(false);
                    setResponceMsg(res.data.message)
                    setToasterType("success")

                    setUpdateSubscriptionState(false);

                    handleGetUserById()

                    // if (subscriptionId) {
                    //     getSubscriptionStatusFn();
                    // }

                    // getSubscriptionStatusFn(res?.data?.data?.updated_subscription_details?.id);

                    getProducts();

                    handleClosePaymentModalTrigger();

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                },
                (res) => {
                    // console.log(res)
                    setResponceMsg(res.data.message)
                    setToasterType("error");

                    setApiResponse(false);

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }
            )
        )
    }

    const chargeProfessionalFn = () => {

        let data = {
            subscription_id_ids: subscriptionId,
            user_id_ids: localStorage.getItem('user_id'),
            role_id_ids: role,
        }
        dispatch(
            chargeProfessionalById(data,
                (res) => {
                    // console.log(res.data.data, "subcription status")
                    console.log(res)
                },
                (res) => {
                    console.log(res)
                })
        )
    }

    // Payment confirm modal functions
    const [paymentConfirmModal, setPaymentConfirmModal] = useState(false);
    const handleOpenPaymentModalTrigger = (element) => {
        setPaymentConfirmModal(true);
        setIndividualSubObj(element);
        setProductId(element?.id);
    }
    const handleClosePaymentModalTrigger = () => {
        setPaymentConfirmModal(false);
        setIsPromoCodeErr(false);
        setIsPaymentMethodErr(false);
        setPromoCode("");
        setVerifiedPromoCode('');
        setFinalAmountAfterPromoCodeApplied(0);
        setApiResponse(false);
        setNumberOfLicenses(subscriptionLicenseQuantity || 1);
        setIsAddingLicenses(false);
    }


    // Check promocode functions
    const [promoCode, setPromoCode] = useState("");
    const [verifiedPromoCode, setVerifiedPromoCode] = useState('');
    const [isPromoCodeErr, setIsPromoCodeErr] = useState(false);
    const [promoCodeLoading, setPromoCodeLoading] = useState(false);
    const [finalAmountAfterPromoCodeApplied, setFinalAmountAfterPromoCodeApplied] = useState(0);

    console.log(promoCode, 'promoCode')



    const handlePromoCode = (e) => {
        setIsPromoCodeErr(false);
        setIsPaymentMethodErr(false);
        setPromoCode(e.target.value);

    }

    const handlePromoCodeBlurCheck = () => {
        if (promoCode === "") {
            setIsPromoCodeErr(false);
        }
    }

    const handleCheckPromoCodeFn = () => {
        setPromoCodeLoading(true);

        let data = {
            promo_code_chr: promoCode,
            type_chr: "TRIAL",
            user_id_ids: localStorage.getItem('user_id'),
            product_id_chr: productId,
            // individualSubObj?.is_company_plan_flag && amount_in_dollar_int: individualSubObj?.price_details?.unit_amount_in_dollars,
            ...(individualSubObj?.is_company_plan_flag && {
                amount_in_dollar_int: (priceAfterLicenses / 100)
            }),
        }
        dispatch(
            checkPromoCode(
                data,
                (res) => {
                    console.log(res)
                    setVerifiedPromoCode(promoCode);

                    setFinalAmountAfterPromoCodeApplied(res?.data?.data?.amount_to_be_charged_for_a_subscription_in_dollars_after_discount);
                    // console.log(res?.data?.data?.amount_to_be_charged_for_a_subscription_in_dollars_after_discount, "final amoubt")
                    setIsPromoCodeErr(false);
                    setPromoCodeLoading(false);
                    setResponceMsg(res.data.message);
                    setToasterType("success");

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                },
                (res) => {
                    // console.log(res)
                    setIsPromoCodeErr(true);
                    setPromoCodeLoading(false);
                    // setResponceMsg(res.data.message)
                    // setToasterType("error");


                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                }
            )
        )
    }

    let USDollar = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    // Get payment method list functions 
    const [supportedPaymentMethodsArr, setSupportedPaymentMethodsArr] = useState([]);
    const [customLoadingForSupportedMethods, setCustomLoadingForSupportedMethods] = useState(false);
    const [getSupportedPaymentFlag, setGetSupportedPaymentFlag] = useState(false);

    // Add new Payment method modal functions
    const [addNewPaymentMethodTrigger, setAddNewPaymentMethodTrigger] = useState(false);
    const handleCloseAddNewPaymentMethod = () => {
        setAddNewPaymentMethodTrigger(false);
        // handleClearCardStates();
    }
    const handleOpenAddNewPaymentMethod = () => {
        setAddNewPaymentMethodTrigger(true);
        setGetSupportedPaymentFlag(true);
        setPaymentConfirmModal(false);
    }

    const getPaymentMethodSupportedListFn = () => {
        let details = {}
        setCustomLoadingForSupportedMethods(true);
        dispatch(
            getPaymentMethodSupportedList(details,
                (res) => {
                    // console.log(res.data.data)
                    console.log(res?.data?.data)
                    setSupportedPaymentMethodsArr(res?.data?.data)
                    setCustomLoadingForSupportedMethods(false);
                },
                (res) => {
                    // console.log(res.data.data)
                    setCustomLoadingForSupportedMethods(false);
                })
        )
    }

    useEffect(() => {
        if (getSupportedPaymentFlag) {
            getPaymentMethodSupportedListFn()
        }
    }, [getSupportedPaymentFlag])


    // Add new card first time functions
    // Add new card modal functions
    const [addCardFirstTimeTrigger, setAddCardFirstTimeTrigger] = useState(false);
    const handleCloseAddCardFirstTime = () => {
        setAddCardFirstTimeTrigger(false);
        handleClearCardStates();
        setPaymentConfirmModal(true);
    }
    const handleOpenAddCardFirstTime = () => {
        setAddCardFirstTimeTrigger(true);
    }

    const handleClearCardStates = () => {
        setCardInfo({
            cardNumber: '',
            expiryDate: '',
            cvc: '',
            cardHolder: '',
            focus: '',
        })
        setFormatedNumber('')
        setIsCardHolderNameErr(false)
        setIsCardNumberErr(false)
        setIsCardExpErr(false)
        setIsCardCVCErr(false)

        setCardCvcError('')
        setCardExpiryError('')
        setCardNumberError('')

        setZipCode('')
        setIsZipCodeErr(false)
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setApiResponse(true);
        const [month, year] = cardInfo.expiryDate.split('/');
        if (cardInfo.cardHolder.trim() === '') {
            setIsCardHolderNameErr(true);
            setApiResponse(false);
        }
        const cardType = creditCardType(cardInfo.cardNumber);

        if (cardInfo?.cardNumber?.length !== 16 || cardType?.length === 0
            // || !validator.isCreditCard(cardInfo.cardNumber)
        ) {
            setIsCardNumberErr(true);
        }
        if (cardInfo.expiryDate.trim() === ""
            || cardInfo?.expiryDate?.trim()?.length != 5
            || Number(month) > 12
            || Number(year) < Number((new Date()).getFullYear().toString().slice(-2))) {
            setIsCardExpErr(true);
            setApiResponse(false);
        }
        if (cardInfo?.cvc?.length < 3 || cardInfo?.cvc?.trim() === "") {
            setIsCardCVCErr(true);
            setApiResponse(false);
        }

        if ((cardInfo?.cardHolder?.trim() === '') ||
            (cardInfo?.cardNumber?.length !== 16) ||
            (cardType?.length === 0) ||
            // !validator.isCreditCard(cardInfo.cardNumber) ||
            (cardInfo.expiryDate.trim() === ""
                || cardInfo?.expiryDate?.trim()?.length != 5
                || Number(month) > 12
                || Number(year) < Number((new Date()).getFullYear().toString().slice(-2))) ||
            (cardInfo?.cvc?.length < 3 || cardInfo?.cvc?.trim() === "")) {
            setApiResponse(false);
            return
        }

        if (!isCardHolderNameErr && !isCardNumberErr && !isCardExpErr && !isCardCVCErr) {
            // Here you can handle the submission of the credit card information.

            let details = new FormData();

            details.append("user_id_ids", localStorage.getItem("user_id"));
            details.append("name_on_card", cardInfo.cardHolder);
            details.append("card_number", parseInt(cardInfo.cardNumber));
            details.append("expiry_month", parseInt(month));
            details.append("expiry_year", parseInt(year));
            details.append("card_cvc_number", parseInt(cardInfo.cvc));
            details.append("token_chr", "tok_visa");

            dispatch(
                createPaymentMethod(
                    details,
                    (res) => {
                        // console.log(res)
                        setApiResponse(false);
                        setResponceMsg(res.data.message)
                        setToasterType("success")
                        handleCloseAddCardFirstTime();

                        getPaymentMethodList(res?.data?.data?.customer?.id);

                        let details = {
                            user_id_ids: localStorage.getItem('user_id'),
                            role_id_int: localStorage.getItem("roleId"),
                            user_impersonate_flag: 0
                        }
                        dispatch(
                            userById(details, (res) => {
                                dispatch(setUserDetails(res.data.data));
                            }),
                        )

                        setPaymentConfirmModal(true);

                        // setHandleToaster(true);
                        // setTimeout(() => {
                        //     setHandleToaster(false);
                        // }, 11000);
                    },
                    (res) => {
                        // console.log(res)
                        setResponceMsg(res.data.message)
                        setToasterType("error");

                        setApiResponse(false);

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    }
                )
            )
        }
    };


    // Check the conditions before confirming the subscription
    // const [conditionsForSubBtn, setConditionsForSubBtn] = useState(false)

    // useEffect(() => {
    //     if (!individualSubObj) {
    //         alert(individualSubObj.id)
    //         if (individualSubObj.id == "prod_free_trial_01") {
    //             if (verifiedPromoCode) {
    //                 console.log("verified code", verifiedPromoCode);
    //                 setConditionsForSubBtn(true)
    //             }
    //         }
    //         if (individualSubObj.id !== "prod_free_trial_01" && cardArr.length > 0) {
    //             console.log("card arra", conditionsForSubBtn);
    //             setConditionsForSubBtn(true)
    //         }
    //     }
    // }, [individualSubObj, cardArr, verifiedPromoCode])

    // console.log("condition", conditionsForSubBtn);

    // cancel subscription modal triggers
    const [cancelSubModalTrigger, setCancelSubModalTrigger] = useState(false);
    const handleOpenCancelSubModal = () => {
        setCancelSubModalTrigger(true);
    }
    const handleCloseCancelSubModal = () => {
        setCancelSubModalTrigger(false);
    }

    const stripe = useStripe();
    const elementsStripe = useElements();

    const handleSubmitStripe = async (event) => {
        event.preventDefault();
        setApiResponse(true);

        const isValidZipCode = validateZipCode();

        if (cardInfo.cardHolder.trim() === '' || !isValidZipCode) {
            if (cardInfo.cardHolder.trim() === '') {
                setIsCardHolderNameErr(true);
                setApiResponse(false);
            }

            // if (zipCode.trim() === '') {
            //     setIsZipCodeErr(true);
            //     setApiResponse(false);
            // }

        } else {
            if (!stripe || !elementsStripe) {
                // Ensure Stripe.js has loaded
                console.log('Stripe has not loaded yet');
                setApiResponse(false);

                setResponceMsg('Stripe has not loaded yet')
                setToasterType("error");
                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);

                return;
            }

            // const cardElement = elements.getElement(CardElement);
            const cardElement = elementsStripe.getElement(CardNumberElement);


            // const cardNumberElement = elements.getElement(CardNumberInput);
            // const cardExpiryElement = elements.getElement(CardExpiryInput);
            // const cardCvcElement = elements.getElement(CardCvcInput);

            const { error, token } = await stripe.createToken(cardElement, {
                address_zip: zipCode,
            });

            if (error) {
                console.log('Error:', error.message);
                setApiResponse(false);

                // setResponceMsg(error.message)
                // setToasterType("error");
                // setHandleToaster(true);
                // setTimeout(() => {
                //     setHandleToaster(false);
                // }, 2000);

            } else {
                console.log('Success! Token: ', token);
                // console.log('Token created:', token.id);
                // You can now send the token to your server

                let details = new FormData();

                details.append("user_id_ids", localStorage.getItem("user_id"));
                details.append("name_on_card", cardInfo.cardHolder);
                details.append("token_chr", token.id);

                details.append("zip_code_chr", zipCode);
                details.append("country_code_chr", myCountryCode);

                setApiResponse(true);

                dispatch(
                    createPaymentMethod(
                        details,
                        (res) => {
                            // console.log(res)
                            setApiResponse(false);

                            setResponceMsg(res.data.message)
                            setToasterType("success")

                            handleCloseAddCardFirstTime();

                            getPaymentMethodList(res?.data?.data?.customer?.id);

                            let details = {
                                user_id_ids: localStorage.getItem('user_id'),
                                role_id_int: localStorage.getItem("roleId"),
                                user_impersonate_flag: 0
                            }
                            dispatch(
                                userById(details, (res) => {
                                    dispatch(setUserDetails(res.data.data));
                                }),
                            )

                            setPaymentConfirmModal(true);

                            // setHandleToaster(true);
                            // setTimeout(() => {
                            //     setHandleToaster(false);
                            // }, 11000);
                        },
                        (res) => {
                            // console.log(res)
                            setResponceMsg(res.data.message)
                            setToasterType("error");

                            setApiResponse(false);

                            setHandleToaster(true);
                            setTimeout(() => {
                                setHandleToaster(false);
                            }, 11000);
                        }
                    )
                )
            }
        }



    }

    const [cardNumberError, setCardNumberError] = useState('');
    const [cardExpiryError, setCardExpiryError] = useState('');
    const [cardCvcError, setCardCvcError] = useState('');

    const handleCardNumberChangeStripe = (event) => {
        // setCardNumberError(event.error ? event.error.message : '');
        setCardNumberError(event.error ? 'Enter valid card number' : '');
    };

    const handleCardExpiryChangeStripe = (event) => {
        // setCardExpiryError(event.error ? event.error.message : '');
        setCardExpiryError(event.error ? 'Enter valid exp. date' : '');

    };

    const handleCardCvcChangeStripe = (event) => {
        // setCardCvcError(event.error ? event.error.message : '');
        setCardCvcError(event.error ? 'Enter valid cvc' : '');
    };

    const [zipCode, setZipCode] = useState("");
    const [isZipCodeErr, setIsZipCodeErr] = useState(false);
    const handleZipCode = (e) => {
        // setZipCode(e.target.value.replace(/\D/g, ''))
        setZipCode(e.target.value)
        setIsZipCodeErr(false)
    }

    const handleZipCodeBlurCheck = () => {
        // if (zipCode.trim() === '') {
        //     setIsZipCodeErr(true);
        // }

        validateZipCode();
    }

    const validateZipCode = () => {
        if (!zipCode) {
            setIsZipCodeErr(true);
            setApiResponse(false);
            return false;
        } else if (!isPostalCode(zipCode, myCountryCode || 'any')) {
            setIsZipCodeErr(true);
            setApiResponse(false);
            return false;
        }
        setIsZipCodeErr(false);
        return true;
    };

    // restrict for the company registration
    const [regCompanyConfirmationModalTrigger, setRegCompanyConfirmationModalTrigger] = useState(false);
    const [companyModal, setCompanyModal] = useState(false)
    const [companyModalType, setCompanyModalType] = useState("")
    const handleRegCompanyConfirmationModalTrigger = () => {
        setRegCompanyConfirmationModalTrigger(true);
    };

    const handleCloseRegCompanyConfirmationModalTrigger = () => {
        setRegCompanyConfirmationModalTrigger(false);
    };

    const handleOpenRegisterComp = () => {
        setCompanyModal(true)
        setCompanyModalType("add");
    }

    const handleCloseCompanyModal = () => {
        setCompanyModal(false);
        // handleGetUserById();

        // if (companyId) {
        //     getProducts();
        // }
    }

    // Functions for the Auto buy the free trial product
    const [isAutoBuySubs, setIsAutoBuySubs] = useState(false);

    // Functions for the downgrade the current plan to free plan
    const [downgradeToFreeDefaultPlanModalTrigger, setDowngradeToFreeDefaultPlanModalTrigger] = useState(false);
    const handleOpenDowngradeToFreePlan = () => {
        setDowngradeToFreeDefaultPlanModalTrigger(true);
    }

    const handleCloseDowngradeToFreePlan = () => {
        setDowngradeToFreeDefaultPlanModalTrigger(false);
    }

    return (
        <>
            <div className="row mx-0">
                <div className="col-12 px-0">
                    <>
                        <div className='row mx-0  w-100 mt-2 mb-3' style={{ flex: '1' }}>
                            
                            <div className="d-flex justify-content-center align-items-center text-center fs-6 fw-bold text-black mb-3">
                                {`Want to use Chilll to help your own customers remotely?   Save on expensive travel and get your customers quick answers and help.`}
                            </div>

                            <div className='col-12 px-1 rounded d-flex justify-content-center' >

                                <div className="row mx-0 w-100 justify-content-center">
                                    {!customeSkeletonLoadingProducts ? <>
                                        {rows?.length > 0 ?
                                            <>
                                                {rows?.map((element, index) => {
                                                    return (
                                                        <>
                                                            {(element?.active || element?.id == freeTrialProductId || element?.id == currentProductId) &&
                                                                <div key={index} className='col-md-3 bg-white p-4 border border-light shadow-lg rounded-2 m-2 position-relative overflow-hidden' style={{ minWidth: '300px' }}>
                                                                    <div
                                                                        className="position-absolute font-w700 text-white text-center p-2"
                                                                        style={{
                                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                            left: '-54px',
                                                                            top: '24px',
                                                                            transform: 'rotate(-45deg)',
                                                                            width: '181px',
                                                                            height: '40px',
                                                                            lineHeight: '30px',
                                                                        }}
                                                                    >
                                                                        <span>{element?.name}</span>
                                                                    </div>

                                                                    <div className='row mx-0 w-100 h-100'>

                                                                        <div className="col-12 d-flex flex-column justify-content-between ">
                                                                            <div>
                                                                                {/* {element?.id !== freeTrialProductId && <div style={{ height: '20px' }}></div>} */}
                                                                                <div style={{ height: '25px' }}>
                                                                                    {((element?.id == freeTrialProductId) || (billingCycleAnchorDate && element?.id == currentProductId)) && (freeTrialProductId !== "prod_free_trial_01") ? <div className="col-12 px-0 d-flex justify-content-end align-items-center">
                                                                                        <span
                                                                                            className="fs-7 px-3 py-1 text-white font-w700 rounded-pill"
                                                                                            style={{
                                                                                                background: "rgba(79, 93, 116, 1)",
                                                                                            }}>
                                                                                            {`Free Trial`}
                                                                                        </span>
                                                                                    </div> : ''}
                                                                                </div>
                                                                                <div className="col-12 px-0 d-flex justify-content-center align-items-center my-3">
                                                                                    <div
                                                                                        className="d-flex justify-content-center align-items-center flex-column rounded-circle text-center text-white"
                                                                                        style={{
                                                                                            height: '85px',
                                                                                            width: '85px',
                                                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                            lineHeight: '16px',
                                                                                        }}
                                                                                    >
                                                                                        <span className='fw-bold fs-5'>
                                                                                            {/* Here changes are done as the team plan currently has the same amount */}
                                                                                            {/* {element?.is_company_plan_flag && subscriptionProductAmont ?
                                                                                                `${USDollar.format((subscriptionProductAmont / 100) || 0)}` :
                                                                                                `${USDollar.format(element?.price_details?.unit_amount_in_dollars || 0)}`
                                                                                            } */}
                                                                                            {USDollar.format(element?.price_details?.unit_amount_in_dollars || 0)}
                                                                                        </span>
                                                                                        <span className='fw-500 fs-7'>{`/ ${element?.price_details?.recurring?.interval}`}</span>
                                                                                    </div>
                                                                                </div>

                                                                                {/* <div className='col-12 d-flex  justify-content-center mb-2 px-0 text-black mt-3' style={{}}>
                                                                                <span className='fw-bold fs-3 pe-2'>{`${USDollar.format(element?.price_details?.unit_amount_in_dollars || 0)}`}</span>
                                                                                <span className='fw-500 fs-5'>{`/ ${element?.price_details?.recurring?.interval}`}</span>
                                                                            </div> */}



                                                                                <div className='align-items-center col-12 d-flex justify-content-center my-3 px-0 text-black text-center font-w600' style={{}}>
                                                                                    <span>{element?.description}</span>
                                                                                </div>

                                                                                {element?.id === "prod_free_trial_01" &&
                                                                                    <>
                                                                                        <div className='align-items-center col-12 d-flex justify-content-center my-3 px-0 text-black text-center fs-7 font-w600' style={{}}>
                                                                                            <div>
                                                                                                <span>
                                                                                                    {`You have ${remainingVideoInvitationCount} out of ${totalMonthlyFreeVideoLinkCount} video invitations remaining`}
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </>
                                                                                }

                                                                                {element?.id === "prod_free_trial_01" && (mySubscriptionStatus === "canceled" || freeTrialStatus === "canceled") && !isUpcomingPlanFlag &&
                                                                                    <>
                                                                                        <div className='align-items-center col-12 d-flex justify-content-center my-3 px-0 text-center fs-7 text-black font-w600' style={{}}>
                                                                                            <div>
                                                                                                <span>
                                                                                                    {`Your free plan will starts from ${convertUnixTime(activeSubscriptionEndTime)}`}
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </>
                                                                                }

                                                                                {/* Currently company plans number licenses are not available */}
                                                                                {element?.is_company_plan_flag && false &&
                                                                                    <>
                                                                                        {subscriptionProductAmont && subscriptionLicenseQuantity >= 1 && (element?.id === currentProductId || element?.id === freeTrialProductId) ?
                                                                                            <div className='align-items-center col-12 d-flex justify-content-center my-3 px-0 text-center fs-7 font-w600' style={{}}>
                                                                                                <div>
                                                                                                    <span>{`You bought ${subscriptionLicenseQuantity} license${subscriptionLicenseQuantity > 1 ? 's' : ''} for ${USDollar.format((subscriptionProductAmont / 100) || 0)}. `}</span>
                                                                                                    {/* {(mySubscriptionStatus !== "canceled" && upcomingSubscriptionStatus !== 1) ? <> */}
                                                                                                    {(mySubscriptionStatus !== "canceled" && !isUpcomingPlanFlag) ? <>
                                                                                                        <span>{`You can `}</span>
                                                                                                        <span
                                                                                                            className="text-success hover-text-underline cursor-pointer"
                                                                                                            onClick={() => {
                                                                                                                setIsAddingLicenses(true);
                                                                                                                handleOpenPaymentModalTrigger(element);
                                                                                                            }}
                                                                                                        >
                                                                                                            {`add`}
                                                                                                        </span>
                                                                                                        <span>{` more licenses anytime.`}</span>
                                                                                                    </> : <></>}
                                                                                                </div>
                                                                                            </div> :
                                                                                            <div className='align-items-center col-12 d-flex justify-content-center my-3 px-0 text-black fs-7 font-w600' style={{}}>
                                                                                                <div>
                                                                                                    <span>{`Starts at price ${USDollar.format(element?.price_details?.unit_amount_in_dollars || 0)} for 1 license`}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        }
                                                                                    </>
                                                                                }

                                                                                {element?.id == currentProductId && <>
                                                                                    {/* {(mySubscriptionStatus === "active" && upcomingSubscriptionStatus == 0 && !billingCycleAnchorDate) && */}
                                                                                    {(mySubscriptionStatus === "active" && !billingCycleAnchorDate) &&

                                                                                        <div className='align-items-center col-12 d-flex justify-content-center my-3 px-0 text-center fs-7' style={{}}>
                                                                                            <div>
                                                                                                <span>{`Your subscription will ${(subscriptionType == "Paid" && !isUpcomingPlanFlag) ? "automatically renew" : "ends"}  on ${convertUnixTime(currentPeriodEndTime)}.`}</span>

                                                                                                {!isUpcomingPlanFlag && <>
                                                                                                    <span>{` You can `}</span>
                                                                                                    <span
                                                                                                        className="text-danger fw-bold cursor-pointer hover-text-underline"
                                                                                                        style={{ color: '' }}
                                                                                                        onClick={() => handleOpenCancelSubModal()}
                                                                                                    >
                                                                                                        {`cancel`}
                                                                                                    </span>
                                                                                                    <span>{` it at anytime.`}</span>
                                                                                                </>}
                                                                                            </div>
                                                                                        </div>
                                                                                    }

                                                                                    {(billingCycleAnchorDate) ?
                                                                                        <div className='align-items-center col-12 d-flex justify-content-center my-3 px-0 text-center fs-7' style={{}}>
                                                                                            <div>
                                                                                                <span>{`Your free trial will end on ${convertUnixTime(currentPeriodEndTime)} and your billing cycle will start on ${convertUnixTime(billingCycleAnchorDate)}. You can `}</span>
                                                                                                <span
                                                                                                    className="text-danger fw-bold cursor-pointer hover-text-underline"
                                                                                                    style={{ color: '' }}
                                                                                                    onClick={() => handleOpenCancelSubModal()}
                                                                                                >
                                                                                                    {`cancel`}
                                                                                                </span>
                                                                                                <span>{` it at anytime.`}</span>
                                                                                            </div>
                                                                                        </div> : ''
                                                                                    }

                                                                                    {/* {(mySubscriptionStatus === "canceled" || upcomingSubscriptionStatus == 1) && */}
                                                                                    {(mySubscriptionStatus === "canceled") &&

                                                                                        <div className='align-items-center col-12 d-flex justify-content-center my-3 px-0 text-center fs-7' style={{}}>
                                                                                            <div>
                                                                                                <span>{`You've cancelled this subscription plan, you will receive this plan services upto ${convertUnixTime(currentPeriodEndTime)}.`}</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    }
                                                                                </>}

                                                                                {element?.id == freeTrialProductId &&
                                                                                    <>
                                                                                        {freeTrialStatus === "active" && freeTrialProductId !== "prod_free_trial_01" &&
                                                                                            <div className='align-items-center col-12 d-flex justify-content-center my-3 px-0 text-center fs-7' style={{}}>
                                                                                                <div>
                                                                                                    <span>{`Your free trial ends on ${convertUnixTime(activeSubscriptionEndTime)}.`}</span>
                                                                                                    {/* <span
                                                                                                className="text-danger fw-bold cursor-pointer hover-text-underline"
                                                                                                style={{}}
                                                                                                onClick={() => handleOpenCancelSubModal()}
                                                                                            >
                                                                                                {`cancel`}
                                                                                            </span>
                                                                                            <span>{` it at any time.`}</span> */}
                                                                                                </div>
                                                                                            </div>
                                                                                        }

                                                                                        {freeTrialStatus === "active" && freeTrialProductId !== "prod_free_trial_01" &&
                                                                                            <div className='align-items-center col-12 d-flex justify-content-center my-3 px-0 text-center fs-7' style={{}}>
                                                                                                <div className="d-flex">
                                                                                                    {/* <div>
                                                                                                        <input
                                                                                                            type="checkbox"
                                                                                                            className="form-check-input"
                                                                                                            id="subsc"
                                                                                                            name="subsc"
                                                                                                            onChange={(e) => {
                                                                                                                setIsAutoBuySubs(!isAutoBuySubs);
                                                                                                                handleOpenPaymentModalTrigger(element);
                                                                                                            }}
                                                                                                            value={isAutoBuySubs}
                                                                                                            // checked={isAutoBuySubs}
                                                                                                            checked={false}
                                                                                                        />
                                                                                                    </div> */}
                                                                                                    <span
                                                                                                        className='ps-3 font-w600 pt-1'
                                                                                                        onClick={() => {
                                                                                                            setIsAutoBuySubs(!isAutoBuySubs);
                                                                                                            handleOpenPaymentModalTrigger(element);
                                                                                                        }}
                                                                                                    >
                                                                                                        <span className="cursor-pointer hover-text-underline text-blue">{`Buy now`}</span> {`to continue using this plan. You will be charged after the trial period ends.`}
                                                                                                    </span>

                                                                                                </div>
                                                                                            </div>
                                                                                        }

                                                                                        {freeTrialStatus === "canceled" && freeTrialProductId !== "prod_free_trial_01" &&
                                                                                            <div className='align-items-center col-12 d-flex justify-content-center my-3 px-0 text-center fs-7' style={{}}>
                                                                                                <div>
                                                                                                    <span>{`You've cancelled this subscription plan, you will receive this plan services upto ${convertUnixTime(activeSubscriptionEndTime)}.`}</span>
                                                                                                </div>
                                                                                            </div>
                                                                                        }
                                                                                    </>
                                                                                }

                                                                                {(isUpcomingPlanFlag && element?.id == upcomingPlanProductId) &&
                                                                                    <>
                                                                                        <div className='align-items-center col-12 d-flex justify-content-center my-3 px-0 text-center fs-7 font-w600' style={{}}>
                                                                                            <div>
                                                                                                <span>
                                                                                                    {`Your upcoming plan will start from ${convertUnixTime(upcomingPlanStartDate)}.`}
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </>
                                                                                }

                                                                                <div className="">
                                                                                    {element?.features?.map((data, index) => {
                                                                                        return (
                                                                                            <div key={index} className='align-items-center col-12 d-flex font-w500 mb-2 px-2 ' style={{}}>
                                                                                                <span className='me-2' style={{ color: '#09d909', fontSize: '18px' }}><i className="bi bi-check-circle"></i></span>
                                                                                                <span>{data.name}</span>
                                                                                            </div>
                                                                                        )
                                                                                    })}
                                                                                </div>
                                                                            </div>

                                                                            {/* Bottom action buttons */}
                                                                            <div>
                                                                                <div className='col-12 d-flex justify-content-center align-items-center px-0 mt-3' style={{}}>
                                                                                    <div className='row mx-0 w-100'>

                                                                                        {element?.id == currentProductId &&
                                                                                            <>
                                                                                                {(mySubscriptionStatus === "active" || mySubscriptionStatus === "canceled") ?
                                                                                                    <div
                                                                                                        className='align-items-center border border-light col-12 d-flex font-w600 justify-content-center p-2  rounded'
                                                                                                        style={{
                                                                                                            background: 'rgba(235, 240, 250, 1)',
                                                                                                            color: 'rgb(40 56 83)',
                                                                                                            height: '40px'
                                                                                                        }}
                                                                                                    >
                                                                                                        <span className="me-2" style={{ color: "#09d909" }}>
                                                                                                            <i className="bi bi-check-lg"></i>
                                                                                                        </span>
                                                                                                        <span className='font-w600'>{"CURRENT PLAN"}</span>
                                                                                                    </div>
                                                                                                    :
                                                                                                    <div className='align-items-center col-12 d-flex font-w600 justify-content-center pt-2 px-0 rounded'
                                                                                                        style={{
                                                                                                            // pointerEvents: "none",
                                                                                                            // opacity: "0.5"
                                                                                                        }}
                                                                                                    >
                                                                                                        <PrimaryButton
                                                                                                            onClick={() => handleOpenPaymentModalTrigger(element)}
                                                                                                            buttonName={mySubscriptionStatus === "incomplete" ? "MAKE PAYMENT" : "BUY NOW"}
                                                                                                            // buttonName={"BUY NOW"}
                                                                                                            style={{
                                                                                                                width: '100%',
                                                                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                                                border: 'none',
                                                                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                                                fontWeight: '600',
                                                                                                            }}
                                                                                                        />
                                                                                                    </div>
                                                                                                }
                                                                                            </>
                                                                                        }

                                                                                        {element?.id == 'prod_free_trial_01' && (mySubscriptionStatus === "active" || freeTrialStatus === "active") && !isUpcomingPlanFlag &&
                                                                                            <>
                                                                                                <div className='align-items-center col-12 d-flex font-w600 justify-content-center pt-2 px-0 rounded'
                                                                                                    style={{
                                                                                                        // pointerEvents: "none",
                                                                                                        // opacity: "0.5"
                                                                                                    }}
                                                                                                >
                                                                                                    <PrimaryButton
                                                                                                        onClick={() => handleOpenDowngradeToFreePlan()}
                                                                                                        buttonName={"DOWNGRADE"}
                                                                                                        // buttonName={"BUY NOW"}
                                                                                                        style={{
                                                                                                            width: '100%',
                                                                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                                            border: 'none',
                                                                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                                            fontWeight: '600',
                                                                                                        }}
                                                                                                    />
                                                                                                </div>
                                                                                            </>
                                                                                        }

                                                                                        {element?.id == freeTrialProductId &&
                                                                                            <>
                                                                                                <div
                                                                                                    className='align-items-center border border-light col-12 d-flex font-w600 justify-content-center p-2 rounded'
                                                                                                    style={{
                                                                                                        background: 'rgba(235, 240, 250, 1)',
                                                                                                        color: 'rgb(40 56 83)',
                                                                                                        height: '40px'
                                                                                                    }}
                                                                                                >
                                                                                                    <span className="me-2" style={{ color: "#09d909" }}>
                                                                                                        <i className="bi bi-check-lg"></i>
                                                                                                    </span>
                                                                                                    <span className=''>{"CURRENT PLAN"}</span>
                                                                                                </div>
                                                                                            </>
                                                                                        }

                                                                                        {(isUpcomingPlanFlag && element?.id == upcomingPlanProductId) ?
                                                                                            <>
                                                                                                <div
                                                                                                    className='align-items-center border border-light col-12 d-flex font-w600 justify-content-center p-2 rounded'
                                                                                                    style={{
                                                                                                        background: 'rgba(235, 240, 250, 1)',
                                                                                                        color: 'rgb(40 56 83)',
                                                                                                        height: '40px'
                                                                                                    }}
                                                                                                >
                                                                                                    <span className="me-2" style={{ color: "#09d909" }}>
                                                                                                        <i className="bi bi-check-lg"></i>
                                                                                                    </span>
                                                                                                    <span className=''>{"UPCOMING PLAN"}</span>
                                                                                                </div>
                                                                                            </> :

                                                                                            (element?.id !== currentProductId && element?.id !== freeTrialProductId && element?.id !== "prod_free_trial_01") ?
                                                                                                <>
                                                                                                    <div className='align-items-center col-12 d-flex font-w600 justify-content-center pt-2 px-0 rounded'
                                                                                                        style={{
                                                                                                            // pointerEvents: "none",
                                                                                                            // opacity: "0.5"
                                                                                                        }}
                                                                                                    >
                                                                                                        <PrimaryButton
                                                                                                            onClick={() => {
                                                                                                                if (element?.is_company_plan_flag && !companyId) {
                                                                                                                    handleRegCompanyConfirmationModalTrigger()
                                                                                                                } else {
                                                                                                                    handleOpenPaymentModalTrigger(element)
                                                                                                                }
                                                                                                            }}
                                                                                                            // buttonName={currentProductPrice <= element?.price_details?.unit_amount_in_dollars ? "UPGRADE" : "DOWNGRADE"}
                                                                                                            buttonName={"BUY NOW"}
                                                                                                            style={{
                                                                                                                width: '100%',
                                                                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                                                border: 'none',
                                                                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                                                fontWeight: '600',
                                                                                                            }}
                                                                                                        />
                                                                                                    </div>
                                                                                                </>
                                                                                                : ''
                                                                                        }

                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            }
                                                        </>
                                                    )
                                                })}
                                            </> :
                                            <>
                                                <div
                                                    className="d-flex justify-content-center align-items-center"
                                                    style={{ minHeight: '400px' }}
                                                >
                                                    <span className="fs-5 fw-500 text-center">{"Currently no subscription plans available"}</span>
                                                </div>
                                            </>
                                        }
                                    </> :
                                        <>
                                            <div
                                                className='h-100 rounded d-flex justify-content-center align-items-center'
                                                style={{ minHeight: '400px' }}
                                            >
                                                {/* <Spinner size="sm"/> */}
                                                <SkeletonDivElement rows={2} height={"400px"} width={"350px"} marginBottom={"5px"} marginRight={'10px'} borderRadius={"5px"} />
                                            </div>
                                        </>
                                    }
                                </div>

                            </div>
                        </div>
                    </>



                </div>
            </div >


            {/* <div>
                <Card style={{ minHeight: '75vh' }}>
                    <Card.Body>

                        <div className="d-flex align-items-center" style={{ justifyContent: 'space-between', marginBottom: '20px' }}>
                            <div className="" style={{ fontSize: '16px', fontWeight: 700 }}>{"Subscription"}</div>
                            {updateSubscriptionState ?
                                <div onClick={() => setUpdateSubscriptionState(false)} style={{ cursor: 'pointer', padding: '0px 20px', fontSize: '24px' }}>
                                    <i class="bi bi-arrow-right"></i>
                                </div> :
                                <div></div>
                            }
                        </div>
                        {!subscriptionId || updateSubscriptionState ?
                            <div className="subscription-plan-main-container">
                                {customeSkeletonLoadingProducts ?
                                    <>
                                        <SkeletonDivElement height={"450px"} width={"250px"} marginBottom={"2px"} marginRight={"5px"} borderRadius={"15px"} />
                                        <SkeletonDivElement height={"450px"} width={"250px"} marginBottom={"2px"} marginRight={"5px"} borderRadius={"15px"} />
                                        <SkeletonDivElement height={"450px"} width={"250px"} marginBottom={"2px"} marginRight={"5px"} borderRadius={"15px"} />
                                        <SkeletonDivElement height={"450px"} width={"250px"} marginBottom={"2px"} marginRight={"5px"} borderRadius={"15px"} />
                                    </> :
                                    <>
                                        {rows.length > 0 &&
                                            <>


                                                {rows.map((element, index) => {
                                                    return (
                                                        <div key={index} className="subscription-plan-individual-container">
                                                            <div className="subscription-plan-image-container">
                                                                <img className="subscription-plan-image"
                                                                    src={element?.images[0]}
                                                                    alt="Subscription Plan"
                                                                />
                                                            </div>

                                                            <div className="subscription-plan-details-container">
                                                                <span>{element?.description}</span>
                                                                <span><strong>Type:</strong> {element?.name}</span>
                                                                <span><strong>Price:</strong> $ {element?.price_details.unit_amount / 100}/{element?.price_details.recurring.interval}</span>
                                                            </div>

                                                            <div className="subscription-plan-action-btn-container">
                                                                <PrimaryButton
                                                                    onClick={() => hanldeOpenPaymentModal(element)}
                                                                    buttonName={"Subscribe"}
                                                                />
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                                }
                                            </>
                                        }
                                    </>
                                }

                            </div> :
                            <>
                                <div>
                                    <p>Your subcription details</p>

                                    {customeSkeletonLoadingSubscription ?
                                        <SkeletonDivElement height={"250px"} width={"280px"} marginBottom={"2px"} borderRadius={"15px"} /> :
                                        <div className="my-subscription-details-container">
                                            <div className="my-subscription-details-heading">
                                                <span>{mySubscriptionName}</span>
                                            </div>

                                            <div style={{ marginBottom: '10px' }}>
                                                <span>Subscription Status : <strong>{mySubscriptionStatus}</strong></span>
                                            </div>

                                            <div className="my-subscription-invoice-download">
                                                <a href={mySubscritionInvoice} target="_blank" rel="noreferrer" download>
                                                    <i className="bi bi-file-earmark-arrow-down-fill" style={{ fontSize: '20px', marginRight: '10px' }}></i>
                                                    <span className="my-subscription-invoice-download-txt">Download Invoice</span>
                                                </a>
                                            </div>

                                            <div className="my-subscription-details-action">
                                                {mySubscriptionStatus == "active" &&
                                                    <div>
                                                        <PrimaryButton
                                                            buttonName={"Update"}
                                                            onClick={() => setUpdateSubscriptionState(true)}
                                                        />
                                                    </div>
                                                }

                                                <div>
                                                    <PrimaryButton
                                                        buttonName={"Cancel"}
                                                        onClick={() => cancelSubscriptionFn()}
                                                    />
                                                </div>

                                            </div>
                                        </div>
                                    }




                                </div>
                            </>
                        }

                    </Card.Body>
                </Card>
            </div > */}

            {/* Old modal for payment */}
            <Modal className="fade" show={paymentModal}>
                <Modal.Header style={{ borderBottom: 'none' }}>
                    <Modal.Title>
                        {!customerID ? "Please save card details" : 'Payment confirmation'}
                    </Modal.Title>
                    {/* <Button
            variant=""
            className="btn-close btn-close-service"
            onClick={() => handleClose()}
          >

          </Button> */}
                </Modal.Header>
                <Modal.Body>
                    {!customerID ? <>
                        <div>
                            <Cards
                                number={cardInfo.cardNumber}
                                name={cardInfo.cardHolder}
                                expiry={cardInfo.expiryDate}
                                cvc={cardInfo.cvc}
                                focused={cardInfo.focus}
                            />

                        </div>

                        {/* <form  style={{ marginTop: '20px' }}> */}
                        <div style={{ marginTop: '20px' }}>
                            <InputField
                                labelName="Cardholder Name"
                                placeholderName={'Cardholder Name'}
                                type={'text'}
                                name={'cardHolder'}
                                value={cardInfo.cardHolder}
                                onChange={handleInputChange}
                                onFocus={handleInputFocus}
                                onBlur={handleCardHolderNameBlurCheck}
                                errorOccured={isCardHolderNameErr}
                                errorMeesage={'Enter valid cardholder name'}
                            />

                            <InputField
                                labelName="Card Number"
                                placeholderName={'1234 1234 1234 1234'}
                                type={'text'}
                                name={'cardNumber'}
                                // value={cardInfo.cardHolder}
                                onChange={handleCardNumberChange}
                                onFocus={handleInputFocus}
                                maxLength={19}
                                onBlur={handleCardNumberBlurCheck}
                                errorOccured={isCardNumberErr}
                                errorMeesage={'Enter valid card number'}
                            />

                            <div className='combine-input-fileds' >
                                <div className='comapany-address' style={{ width: '49%' }}>
                                    <InputField
                                        labelName="Expiry Date"
                                        placeholderName={'MM/YY'}
                                        type={'text'}
                                        name={'expiryDate'}
                                        value={cardInfo.expiryDate}
                                        onChange={handleExpiryDateChange}
                                        onFocus={handleInputFocus}
                                        onBlur={handleCardExpBlurCheck}
                                        errorOccured={isCardExpErr}
                                        errorMeesage={'Enter valid exp. date'}
                                    />
                                </div>

                                <div className='comapany-address' style={{ width: '49%' }}>
                                    <InputField
                                        labelName="CVC"
                                        placeholderName={'CVC'}
                                        type={'text'}
                                        name={'cvc'}
                                        value={cardInfo.cvc}
                                        onChange={handleCVCChange}
                                        onFocus={handleInputFocus}
                                        onBlur={handleCardCVCBlurCheck}
                                        errorOccured={isCardCVCErr}
                                        errorMeesage={'Enter valid cvc'}
                                        maxLength={4}
                                    />
                                </div>
                            </div>

                            <div style={{ marginTop: '20px', color: 'red' }}>
                                <span><strong>Note:</strong> By clicking on below save button, you agree to pay <strong>${subscriptionPrice}</strong></span>
                            </div>

                            <div className='d-flex align-items-center' style={{ marginTop: '10px', justifyContent: 'flex-end' }}>

                                <div>
                                    <PrimaryButton
                                        buttonName={"Save card"}
                                        onClick={(e) => { handleSubmitPay(e) }}
                                    />
                                </div>

                                <div style={{ marginLeft: '5px' }}>
                                    <PrimaryButton
                                        buttonName={"Cancel"}
                                        onClick={() => {
                                            setPaymentModal(false);
                                            setPaymentConfirmModal(true);
                                            // handleOpenAddNewPaymentMethod();
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        {/* </form> */}
                    </> :
                        <>
                            <div className="d-flex align-items-center" style={{ justifyContent: 'flex-end' }}>
                                <span>
                                    <i className="bi bi-info-circle-fill" style={{ color: 'red', fontSize: '15px' }}></i>{' '}
                                    <strong onClick={() => handleOpenAddNewCard()} className='update-card-text'>Add new card</strong>
                                </span>
                            </div>
                            <div className="saved-card-container-modal">
                                {/* <Cards
                  number={lastFourDigitCard}
                  name={initialNameOnCard}
                  expiry={`${initialMonthExpCard}${initialYearExpCard}`}
                /> */}
                                {cardArr?.map((element, index) => {
                                    return (
                                        <>
                                            <div className='saved-card-individual-box-modal' key={index}>
                                                <div className='saved-card-individual-actions-modal'>
                                                    <div className='saved-card-individual-name-modal'>
                                                        <i className="bi bi-credit-card-2-back card-icon-modal" ></i>
                                                        <span className='saved-card-individual-type-modal'>{(element?.card?.brand)?.toUpperCase()}</span>
                                                    </div>

                                                    <span></span>
                                                </div>

                                                <div className='saved-card-details-modal' style={{ margin: '5px' }}>
                                                    <span style={{ fontSize: '16px', fontWeight: '600' }}>{`XXXX XXXX XXXX ${element?.card?.last4}`}</span>

                                                    <div className='d-flex align-items-center' style={{ justifyContent: 'space-between', }}>
                                                        <span>{element?.billing_details?.name}</span>
                                                        <span>{`${element?.card?.exp_month}/${element?.card?.exp_year}`}</span>
                                                    </div>

                                                </div>

                                                <div className='saved-card-update-modal'>
                                                    <span onClick={() => handleOpenUpdateCard(element, false)}>
                                                        <i className="bi bi-info-circle-fill" style={{ color: 'red', fontSize: '12px' }}></i>{' '}
                                                        <strong className='update-card-text'>Update card</strong>
                                                    </span>
                                                </div>

                                                <div className='saved-card-primary-check-modal'>
                                                    {!element.is_default_card &&
                                                        <div className='saved-card-primary-box' >
                                                            <div
                                                                onClick={(e) => selectPrimaryCardFn(e, element)}
                                                            >
                                                                <input type='radio' id={element?.id} value={element?.id} name="selectPrimaryCard" style={{ display: 'inline-block', padding: '10px' }} />
                                                                <span style={{ marginLeft: '8px', marginTop: '5px', }}>
                                                                    <label for={element?.id} style={{ cursor: 'pointer' }}>Set as primary card</label >
                                                                </span>
                                                            </div>
                                                        </div>
                                                    }

                                                </div>
                                                {element.is_default_card &&
                                                    <div className='save-card-default-text-modal'>
                                                        Primary card
                                                    </div>
                                                }
                                            </div>
                                        </>
                                    )
                                })}
                            </div>




                            <div style={{ margin: '15px 0px', fontSize: '18px' }}>
                                <span>By clicking on below confirm button, you agree to pay <strong>${subscriptionPrice}</strong></span>
                            </div>


                            <div className='d-flex align-items-center' style={{ marginTop: '10px', justifyContent: 'flex-end' }}>
                                <div>
                                    <PrimaryButton
                                        buttonName={"Yes, I confirm"}
                                        onClick={handleConfirmPay}
                                    />
                                </div>

                                <div style={{ marginLeft: '5px' }}>
                                    <PrimaryButton
                                        buttonName={"Cancel"}
                                        onClick={() => {
                                            setPaymentModal(false);
                                            setPaymentConfirmModal(true);
                                        }}
                                    />
                                </div>

                            </div>
                        </>
                    }
                </Modal.Body>
            </Modal>


            {/* New modal for payment confirmation */}
            <Modal
                className="fade"
                show={paymentConfirmModal}
                style={{}}
                centered
                size="lg"
            >
                <Modal.Body>
                    <div className="row mx-0">
                        <div className="col-12 px-0">
                            <>
                                <div>
                                    <div className='mx-0 row'>
                                        <div className='col-12 d-flex fs-4 justify-content-end px-0 text-black'>
                                            <span onClick={() => handleClosePaymentModalTrigger()} className='cursor-pointer'>
                                                <i className="bi bi-x-lg"></i>
                                            </span>
                                        </div>
                                    </div>

                                    <div className='mx-0 row mb-4'>
                                        <div className='col-12 font-w600 fs-3 px-0 text-center text-black '>
                                            <span>
                                                {`Subscribe to Chilll ${individualSubObj?.name} plan`}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mx-0">
                                    <div className="col-lg-6 pe-lg-2">
                                        <div className=" p-4 border">

                                            <div className="border-bottom mx-0 pb-3 row">
                                                <div className="col-12 px-0 d-flex align-items-center">
                                                    <div className="rounded-circle border" style={{ width: "45px", height: "45px" }}>

                                                    </div>
                                                    <div className="ps-3">
                                                        <span className="fs-4 fw-bold text-black">{`${individualSubObj?.name} plan`}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mx-0 py-2">
                                                <div className="col-12 px-0 d-flex align-items-center">
                                                    <span className="fs-5 font-w600 text-black">{"Order"}</span>
                                                </div>
                                            </div>

                                            <div className="row mx-0 pb-2">
                                                <div className="col-12 px-0 d-flex justify-content-between align-items-center">
                                                    <div className="font-w600">
                                                        <span className="text-black text-capitalize ">{`${individualSubObj?.price_details?.recurring?.interval} `}</span>
                                                        <span className="  text-black">{`subscription`}</span>
                                                    </div>
                                                    <span className=" font-w600 text-black">
                                                        {individualSubObj?.is_company_plan_flag ?
                                                            `${USDollar.format(parseFloat((priceAfterLicenses / 100).toFixed(2)))}` :
                                                            `${USDollar.format(parseFloat(individualSubObj?.price_details?.unit_amount_in_dollars.toFixed(2)))}`
                                                        }
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="row mx-0 pb-2 ">
                                                <div className="col-12 px-0 d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <span className=" text-black">{"Processing fee"}</span>
                                                        <i className="bi bi-info-circle  ps-2"></i>
                                                    </div>
                                                    <span className=" font-w600 text-black">{"$0.00"}</span>
                                                </div>
                                            </div>

                                            {verifiedPromoCode &&
                                                <div className="row mx-0 pb-2  ">
                                                    <div className="col-12 px-0 d-flex justify-content-between align-items-center">
                                                        <div>
                                                            <span className=" text-black">{"Promo code discount"}</span>
                                                        </div>
                                                        {individualSubObj?.is_company_plan_flag ?
                                                            <span className=" font-w600 text-success">{`-${USDollar.format(parseFloat((priceAfterLicenses / 100).toFixed(2)) - parseFloat(finalAmountAfterPromoCodeApplied.toFixed(2)))}`}</span> :
                                                            <span className=" font-w600 text-success">{`-${USDollar.format(parseFloat(individualSubObj?.price_details?.unit_amount_in_dollars.toFixed(2)) - parseFloat(finalAmountAfterPromoCodeApplied.toFixed(2)))}`}</span>
                                                        }
                                                    </div>
                                                </div>
                                            }

                                            <div className="row mx-0 border-bottom"></div>

                                            <div className="row mx-0 py-2 ">
                                                <div className="col-12 px-0 d-flex justify-content-between align-items-center fs-4">
                                                    <span className="  font-w600  text-black">{"Total"}</span>
                                                    <>
                                                        {!verifiedPromoCode &&
                                                            <>
                                                                {individualSubObj?.is_company_plan_flag ?
                                                                    <span className=" font-w600 text-black">
                                                                        {`${USDollar.format(parseFloat((priceAfterLicenses / 100).toFixed(2)))}`}
                                                                    </span> :
                                                                    <span className=" font-w600 text-black">
                                                                        {`${USDollar.format(parseFloat(individualSubObj?.price_details?.unit_amount_in_dollars.toFixed(2)))}`}
                                                                    </span>
                                                                }
                                                            </>
                                                        }
                                                        {verifiedPromoCode &&
                                                            <span className=" font-w600 text-black">
                                                                {`${USDollar.format(parseFloat(finalAmountAfterPromoCodeApplied.toFixed(2)))}`}
                                                            </span>
                                                        }
                                                    </>
                                                </div>
                                            </div>


                                            <div className="row mx-0 py-2 ">
                                                <div className="col-sm-7 pe-sm-1 d-flex  align-items-center">
                                                    <div className="w-100">
                                                        <InputField
                                                            labelName={"Promo code"}
                                                            placeholderName={"Enter promo code"}
                                                            onChange={handlePromoCode}
                                                            onBlur={handlePromoCodeBlurCheck}
                                                            errorOccured={isPromoCodeErr}
                                                            errorMeesage={"enter valid promo code"}
                                                            value={`${promoCode}`}
                                                        />
                                                    </div>
                                                </div>

                                                <div
                                                    className="col-sm-5 ps-sm-1 pb-3"
                                                >
                                                    <PrimaryButton
                                                        buttonName={"Apply"}
                                                        onClick={handleCheckPromoCodeFn}
                                                        loadingMessage={"Checking..."}
                                                        isLoading={promoCodeLoading}
                                                        style={{
                                                            width: '100%',
                                                            background: promoCodeLoading || promoCode === "" ? 'lightgray' : '',
                                                            color: promoCodeLoading || promoCode === "" ? 'grey' : '',
                                                            pointerEvents: promoCodeLoading || promoCode === "" ? 'none' : 'auto',
                                                            border: 'none'
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            {verifiedPromoCode && finalAmountAfterPromoCodeApplied == 0 ?
                                                <></> :
                                                <div className="row mx-0 p-3 bg-light">
                                                    <div className="col-12 px-0 d-flex align-items-center">
                                                        <span className="fs-6  text-black">
                                                            {`We will charge ${verifiedPromoCode ? USDollar.format(parseFloat(finalAmountAfterPromoCodeApplied.toFixed(2))) : individualSubObj?.is_company_plan_flag ? USDollar.format(parseFloat((priceAfterLicenses / 100).toFixed(2))) : USDollar.format(parseFloat(individualSubObj?.price_details?.unit_amount_in_dollars.toFixed(2)))} to your saved payment method every ${individualSubObj?.price_details?.recurring?.interval === "month" ? "30 days" : individualSubObj?.price_details?.recurring?.interval === "year" ? "365 days" : ""}   unless you cancel your subscription`}
                                                        </span>
                                                    </div>
                                                </div>
                                            }

                                        </div>
                                    </div>

                                    <div className="col-lg-6 ps-lg-2 d-flex flex-column justify-content-between">

                                        <div className='mt-3 mb-4'>

                                            {/* currently number of licenses is disabled */}
                                            {individualSubObj?.is_company_plan_flag && false &&
                                                <div className="row mx-0">
                                                    <div className="col-12 d-flex">
                                                        <div className="w-100">
                                                            <InputField
                                                                labelName={"Number of licenses"}
                                                                placeholderName={"Number of licenses"}
                                                                onChange={handleNumberOfLicenses}
                                                                onBlur={() => { }}
                                                                errorOccured={false}
                                                                errorMeesage={"Enter number of licenses"}
                                                                value={`${numberOfLicenses}`}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            }

                                            {/* <div className='row mx-0 '>
                                                <div className='col-12 px-0'>
                                                    <label className="mb-1">
                                                        <strong>{"Payment method"}</strong>
                                                    </label>
                                                    <Select
                                                        isSearchable
                                                        name="color"
                                                        placeholder={cardArr.length > 0 ? "Select payment method" : "Add new payment method"}
                                                        styles={{
                                                            control: (provided) => ({
                                                                ...provided,
                                                                borderColor: "rgba(107, 107, 107, 0.12)",
                                                                borderWidth: 2,
                                                                borderRadius: "7px",
                                                                padding: "2px 0px !important",
                                                                marginBottom: "10px",
                                                                boxShadow: "none",
                                                                "&:hover": {
                                                                    borderColor: "rgba(107, 107, 107, 0.12)",
                                                                },
                                                            }),
                                                        }}
                                                        options={cardArr}
                                                        getOptionLabel={(option) => `${option?.card?.brand.toUpperCase()} *${option?.card?.last4}`}
                                                        getOptionValue={(option) => option.description}
                                                        onInputChange={''}
                                                        onChange={(option) => {
                                                            console.log(option)
                                                        }}
                                                    />
                                                </div>
                                            </div> */}



                                            {verifiedPromoCode && finalAmountAfterPromoCodeApplied == 0 ?

                                                <div className="row mx-0">
                                                    <div className="col-12 px-0 text-center">
                                                        <span className="fs-4 fw-bold text-success">
                                                            {"Promo code applied successfully"}
                                                        </span>
                                                    </div>
                                                </div>
                                                :
                                                <div className='row mx-0'>
                                                    <div className='col-12 px-0'>
                                                        <label className="mb-2">
                                                            <strong>{"Select your preferred payment method"}</strong>
                                                        </label>

                                                        <div className="position-relative">
                                                            <div
                                                                className={`${isPaymentMethodErr && 'border-danger'} w-100 border rounded d-flex justify-content-between align-items-center cursor-pointer`}
                                                                style={{
                                                                    height: "40px",
                                                                }}
                                                                onClick={() => {
                                                                    setToggleCardsMenu(!toggleCardsMenu);
                                                                    setIsPaymentMethodErr(false);
                                                                }}
                                                            >
                                                                <div className="ps-3 ">
                                                                    {cardArr?.length > 0 ?
                                                                        <>
                                                                            {cardArr?.map((element, index) => {
                                                                                return (
                                                                                    <>
                                                                                        {element.is_default_card &&
                                                                                            <>
                                                                                                <span className="font-w600 text-black">
                                                                                                    {`${element?.card?.brand?.toUpperCase()} `}
                                                                                                </span>
                                                                                                <span className="text-black">
                                                                                                    {`*${element?.card?.last4}`}
                                                                                                </span>
                                                                                            </>
                                                                                        }
                                                                                    </>
                                                                                )
                                                                            })}
                                                                        </> :
                                                                        <span
                                                                            className="ps-2"
                                                                        >
                                                                            {`Add new payment method`}
                                                                        </span>
                                                                    }
                                                                </div>



                                                                <div
                                                                    className="fs-4 font-w600 d-flex justify-content-center align-items-center border-start"
                                                                    style={{ height: "25px", width: '35px' }}
                                                                >
                                                                    <i class="bi bi-chevron-down"></i>
                                                                </div>
                                                            </div>

                                                            {isPaymentMethodErr && <small className="text-danger">{`please select payment method`}</small>}

                                                            {toggleCardsMenu &&
                                                                <div
                                                                    className="mt-1 w-100 border rounded d-flex flex-column align-items-center  shadow"
                                                                    style={{
                                                                        pointerEvents: primaryCardLoading ? 'none' : 'auto',
                                                                        opacity: primaryCardLoading ? '0.5' : '1',
                                                                    }}
                                                                >
                                                                    {cardArr?.map((element, index) => {
                                                                        return (
                                                                            <>
                                                                                <div
                                                                                    key={index}
                                                                                    className="border-bottom p-2 text-black w-100 overlay-action-btn d-flex align-items-center cursor-pointer"
                                                                                    onClick={(e) => selectPrimaryCardFn(e, element)}
                                                                                    style={{
                                                                                        pointerEvents: element?.is_default_card ? "none" : "auto",
                                                                                        opacity: element?.is_default_card ? "0.7" : "1",
                                                                                    }}
                                                                                >
                                                                                    <div className="mx-2">

                                                                                        <input
                                                                                            className="form-check-input"
                                                                                            style={{ display: 'inline-block' }}
                                                                                            name="selectCard"
                                                                                            type="radio"
                                                                                            value={`${element?.id}`}
                                                                                            onChange={(e) => { selectPrimaryCardFn(e, element) }}
                                                                                            checked={element?.is_default_card}
                                                                                        />
                                                                                    </div>

                                                                                    <div className="mt-1">
                                                                                        <span className="font-w600">
                                                                                            {`${element?.card?.brand?.toUpperCase()} `}
                                                                                        </span>
                                                                                        <span className="">
                                                                                            {`*${element?.card?.last4}`}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                        )
                                                                    })}

                                                                    <>
                                                                        <div
                                                                            className="align-items-center d-flex overlay-action-btn p-2 text-black w-100 cursor-pointer"
                                                                            onClick={() => {
                                                                                handleOpenAddNewPaymentMethod();
                                                                                setIsPaymentMethodErr(false);
                                                                            }}
                                                                        >
                                                                            <span className="fs-4 mx-2">
                                                                                <i className="bi bi-plus-circle-fill"></i>
                                                                            </span>
                                                                            <span className="font-w600">
                                                                                {`Add new payment method`}
                                                                            </span>
                                                                        </div>
                                                                    </>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>

                                            }
                                        </div>


                                        <div>
                                            <div>
                                                <div className="row mx-0">
                                                    <div
                                                        className="col-12 px-0"
                                                        style={{
                                                            pointerEvents: licensePriceLoading ? "none" : "auto",
                                                            opacity: licensePriceLoading ? "0.5" : "1",
                                                        }}
                                                    >
                                                        <PrimaryButton
                                                            buttonName={"CONFIRM"}
                                                            isLoading={apiResponce}
                                                            loadingMessage={"Loading..."}
                                                            onClick={() => {
                                                                // subscriptionId || freeTrialPrevSubscriptionId ? updateSubscriptionFn() : createSubscriptionFn();
                                                                // console.log("confirm subscription", conditionsForSubBtn)

                                                                // subscriptionId && mySubscriptionStatus !== "canceled" ? updateSubscriptionFn() : createSubscriptionFn();

                                                                updateSubscriptionFn();
                                                            }}
                                                            style={{
                                                                width: '100%',
                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                border: 'none',
                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                fontWeight: '600',
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* <div>
                                                <div className="row mx-0 mt-3">
                                                    <div className="col-12 px-0 d-flex justify-content-center align-items-center flex-column text-black ">
                                                        <div className="text-center">
                                                            <span>{`By pressing the "Submit" button, you agree to Chilll`}</span>
                                                        </div>
                                                        <div className="text-center">
                                                            <a
                                                                className="terms-condition-link"
                                                                href="https://chilll.com/chilll-terms-conditions/"
                                                                target="_blank"
                                                                rel="noreferrer">
                                                                <span className="font-w600 cursor-pointer">{`Terms of Service`}</span>
                                                            </a>
                                                            <span>{` and `}</span>
                                                            <a
                                                                className="terms-condition-link"
                                                                href="https://chilll.com/privacy-policy/"
                                                                target="_blank"
                                                                rel="noreferrer">
                                                                <span className="font-w600 cursor-pointer">{`Privacy Policy`}</span>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div> */}
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div className="row mx-0 mt-3">
                                        <div className="col-12 px-0 d-flex justify-content-center align-items-center flex-column text-black ">
                                            <div className="text-center">
                                                <span>{`By pressing the "CONFIRM" button, you agree to Chilll`}</span>
                                            </div>
                                            <div className="text-center">
                                                <a
                                                    className="terms-condition-link"
                                                    href="https://chilll.com/chilll-terms-conditions/"
                                                    target="_blank"
                                                    rel="noreferrer">
                                                    <span className="font-w600 cursor-pointer">{`Terms of Service`}</span>
                                                </a>
                                                <span>{` and `}</span>
                                                <a
                                                    className="terms-condition-link"
                                                    href="https://chilll.com/privacy-policy/"
                                                    target="_blank"
                                                    rel="noreferrer">
                                                    <span className="font-w600 cursor-pointer">{`Privacy Policy`}</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </>



                        </div>
                    </div>



                </Modal.Body>
            </Modal >

            {/* Modal to add new payment methods */}
            <Modal className="fade" show={addNewPaymentMethodTrigger} centered>
                <Modal.Body>

                    <div className='row mx-0'>
                        <div className='col-12 px-0'>

                            <>
                                <div className='mx-0 row'>
                                    <div className='col-12 d-flex fs-4 justify-content-end px-0 text-black'>
                                        <span onClick={() => {
                                            handleCloseAddNewPaymentMethod();
                                            setPaymentConfirmModal(true);
                                        }} className='cursor-pointer'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className='mx-0 row mb-4'>
                                    <div className='col-12 font-w600 fs-3 px-0 text-center text-black '>
                                        <span>
                                            {"Payment methods"}
                                        </span>
                                    </div>
                                </div>

                                <div className='row mx-0 mb-2'>
                                    <div className={`col-12 px-0 text-center`}>
                                        <span className='font-w600 fs-5'>
                                            {supportedPaymentMethodsArr.length > 0 ? "You can add a new payment method" : "No payment method available"}
                                        </span>
                                    </div>
                                </div>


                                {customLoadingForSupportedMethods ?
                                    <>
                                        <SkeletonDivElement height={'80px'} marginBottom={'10px'} borderRadius={'0px'} />
                                        <SkeletonDivElement height={'80px'} marginBottom={'10px'} borderRadius={'0px'} />
                                        <SkeletonDivElement height={'80px'} marginBottom={'10px'} borderRadius={'0px'} />
                                    </> :
                                    <>
                                        {supportedPaymentMethodsArr?.length > 0 &&
                                            <div>
                                                {supportedPaymentMethodsArr?.map((element, index) => {
                                                    return (
                                                        <>
                                                            <div
                                                                key={index}
                                                                className='row mx-0 border shadow-sm p-3 mb-2 overlay-action-btn cursor-pointer'
                                                                style={{
                                                                    pointerEvents: element?.is_active_ysn ? 'auto' : 'none',
                                                                    opacity: element?.is_active_ysn ? 1 : 0.5,
                                                                }}
                                                                onClick={() => {
                                                                    handleCloseAddNewPaymentMethod();
                                                                    !customerID ? handleOpenAddCardFirstTime() : handleOpenAddNewCard()
                                                                }}
                                                            >
                                                                <div className={`col-12 d-flex align-items-center`}>
                                                                    <div className='align-items-cente bg-light border d-flex fs-3 justify-content-center rounded-circle text-black'
                                                                        style={{ height: '35px', width: '35px', }}
                                                                    >
                                                                        <i class="align-self-center bi bi-gear-wide-connected"></i>
                                                                    </div>

                                                                    <div className='fs-4 font-w600 ps-3 text-black'>
                                                                        <span>
                                                                            {element?.name_chr}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                })}

                                            </div>
                                        }
                                    </>
                                }



                            </>



                        </div>
                    </div>

                </Modal.Body>
            </Modal>


            {/* Modal to cancel the current subscritpion */}
            <Modal className="fade" show={cancelSubModalTrigger} centered>
                <Modal.Body>

                    <div className='row mx-0'>
                        <div className='col-12 px-0'>

                            <>
                                <div className='mx-0 row'>
                                    <div className='col-12 d-flex fs-4 justify-content-end px-0 text-black'>
                                        <span onClick={() => handleCloseCancelSubModal()} className='cursor-pointer'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className='mx-0 row mb-3'>
                                    <div className='col-12 font-w600 fs-3 px-0 text-center text-black '>

                                        <span>
                                            {"Cancel subscription"}
                                        </span>
                                    </div>
                                </div>




                                <div className='row mx-0 mb-3'>
                                    <div className={`col-12 px-0 text-center font-w500 fs-4 `}>
                                        <span>
                                            {"Are you sure you want to cancel your current subscription?"}
                                        </span>
                                    </div>
                                </div>


                                <div className='row mx-0 justify-content-between mt-2'>


                                    <div className='col-12 px-0 mb-2'>
                                        <PrimaryButton
                                            onClick={(e) => { cancelSubscriptionFn() }}
                                            buttonName={"Yes, cancel it"}
                                            type={"submit"}
                                            loadingMessage={"Loading..."}
                                            isLoading={apiResponce}
                                            style={{ width: "100%", background: 'red', border: 'none' }}
                                        />
                                    </div>

                                </div>


                            </>



                        </div>
                    </div>

                </Modal.Body>
            </Modal>

            {/* Modal to DOWNGRADE to free plans */}
            <Modal className="fade" show={downgradeToFreeDefaultPlanModalTrigger} centered>
                <Modal.Body>

                    <div className='row mx-0'>
                        <div className='col-12 px-0'>
                            <>
                                <div className='mx-0 row'>
                                    <div className='col-12 d-flex fs-4 justify-content-end px-0 text-black'>
                                        <span onClick={() => handleCloseDowngradeToFreePlan()} className='cursor-pointer'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className='mx-0 row mb-3'>
                                    <div className='col-12 font-w600 fs-3 px-0 text-center text-black '>

                                        <span>
                                            {"Downgrade to free plan"}
                                        </span>
                                    </div>
                                </div>


                                <div className='row mx-0 my-4'>
                                    <div className={`col-12 px-0 text-center font-w500 fs-4 `}>
                                        <span>
                                            {"To switch to a free plan, your current subscription will be cancelled. However, you’ll continue enjoying all the benefits of your current plan until it expires."}
                                        </span>
                                    </div>
                                </div>


                                <div className='row mx-0 justify-content-between mt-2'>


                                    <div className='col-6 px-0 pe-2 mb-2'>
                                        <PrimaryButton
                                            onClick={(e) => { cancelSubscriptionFn() }}
                                            buttonName={"DOWNGRADE"}
                                            type={"submit"}
                                            loadingMessage={"Loading..."}
                                            isLoading={apiResponce}
                                            style={{
                                                width: '100%',
                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                border: 'none',
                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                fontWeight: '600',
                                            }}
                                        />
                                    </div>

                                    <div className='col-6 px-0 ps-2 mb-2'>
                                        <PrimaryButton
                                            onClick={(e) => { handleCloseDowngradeToFreePlan() }}
                                            buttonName={"CANCEL"}
                                            style={{
                                                width: "100%",
                                                backgroundColor: "white",
                                                border: '1px solid black',
                                                color: 'black',
                                                fontWeight: '600',
                                            }}
                                        />
                                    </div>

                                </div>


                            </>



                        </div>
                    </div>

                </Modal.Body>
            </Modal>

            {/* Modal to add new credit card first time */}
            <Modal className="fade" show={addCardFirstTimeTrigger} centered>
                <Modal.Body>

                    <div className='row mx-0'>
                        <div className='col-12 px-0'>

                            <>
                                <div className='mx-0 row'>
                                    <div className='col-12 d-flex fs-4 justify-content-end px-0 text-black'>
                                        <span onClick={() => handleCloseAddCardFirstTime()} className='cursor-pointer'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className='mx-0 row mb-4'>
                                    <div className='col-12 font-w600 fs-3 px-0 text-center text-black '>
                                        <span>
                                            {"Add new card"}
                                        </span>
                                    </div>
                                </div>

                                <>
                                    <form onSubmit={handleSubmitStripe}>


                                        <div>
                                            {/* <CardInput /> */}

                                            <div className='row mx-0'>
                                                <div className='col-12 px-0'>
                                                    <label className={`font-w600 mb-1 ${cardNumberError ? 'text-red' : ''}`}>Card Number *</label>
                                                    <div
                                                        style={{
                                                            padding: '10px',
                                                            border: cardNumberError ? '1px solid red' : '1px solid #DBDBDB',
                                                            borderRadius: '6px'
                                                        }}
                                                    >
                                                        <CardNumberInput onChange={handleCardNumberChangeStripe} autocomplete="off" />
                                                    </div>
                                                    {cardNumberError && <div className="text-red fs-12">{cardNumberError}</div>}
                                                </div>
                                            </div>

                                            <div className='row mx-0 mt-2'>
                                                <div className='col-6 pe-2'>
                                                    <label className={`font-w600 mb-1 ${cardExpiryError ? 'text-red' : ''}`}>Expiry Date *</label>
                                                    <div
                                                        style={{
                                                            padding: '10px',
                                                            border: cardExpiryError ? '1px solid red' : '1px solid #DBDBDB',
                                                            borderRadius: '6px'
                                                        }}
                                                    >
                                                        <CardExpiryInput onChange={handleCardExpiryChangeStripe} />
                                                    </div>
                                                    {cardExpiryError && <div className="text-red fs-12">{cardExpiryError}</div>}
                                                </div>

                                                <div className='col-6 ps-2'>
                                                    <label className={`font-w600 mb-1 ${cardCvcError ? 'text-red' : ''}`}>CVC *</label>
                                                    <div
                                                        style={{
                                                            padding: '10px',
                                                            border: cardCvcError ? '1px solid red' : '1px solid #DBDBDB',
                                                            borderRadius: '6px'
                                                        }}
                                                    >
                                                        <CardCvcInput onChange={handleCardCvcChangeStripe} />
                                                    </div>
                                                    {cardCvcError && <div className="text-red fs-12">{cardCvcError}</div>}
                                                </div>
                                            </div>

                                            <div className='row mx-0 mt-3'>
                                                <div className='col-12 px-0'>
                                                    <StandardInputField
                                                        labelName="Name on card"
                                                        placeholderName={'Name on card'}
                                                        type={'text'}
                                                        name={'cardHolder'}
                                                        value={cardInfo.cardHolder}
                                                        onChange={handleInputChange}
                                                        onFocus={handleInputFocus}
                                                        onBlur={handleCardHolderNameBlurCheck}
                                                        errorOccured={isCardHolderNameErr}
                                                        errorMeesage={'Enter valid cardholder name'}
                                                        isRequired={true}
                                                    />
                                                </div>
                                            </div>

                                            <div className='row mx-0'>
                                                <div className='col-12 px-0'>
                                                    <StandardInputField
                                                        labelName={"Zip code"}
                                                        placeholderName={'Zip code'}
                                                        value={zipCode}
                                                        onChange={(e) => { handleZipCode(e) }}
                                                        onBlur={() => { handleZipCodeBlurCheck() }}
                                                        errorOccured={isZipCodeErr}
                                                        errorMeesage={`Enter valid zip code`}
                                                        isRequired={true}
                                                    />
                                                </div>
                                            </div>

                                            <div className='col-12 px-0  mt-2'>
                                                <PrimaryButton
                                                    onClick={(e) => handleSubmitStripe(e)}
                                                    buttonName={"ADD NEW CARD"}
                                                    type={"submit"}
                                                    loadingMessage={"LOADING..."}
                                                    isLoading={apiResponce}
                                                    style={{
                                                        width: '100%',
                                                        background: 'linear-gradient(142.98deg, rgb(22, 186, 78) 1.99%, rgb(25, 223, 92) 99.97%)',
                                                        border: 'none',
                                                        boxShadow: 'rgba(45, 204, 99, 0.24) 0px 6px 12px 0px',
                                                    }}
                                                    disabled={!stripe}
                                                />
                                            </div>

                                        </div>

                                    </form>
                                </>

                                {/* <>
                                    <form onSubmit={handleSubmit} style={{ marginTop: '20px' }}>

                                        <div className='row mx-0'>
                                            <div className={`col-12 px-0 `}>
                                                <InputField
                                                    labelName="Card number"
                                                    placeholderName={'1234 1234 1234 1234'}
                                                    type={'text'}
                                                    name={'cardNumber'}
                                                    value={formatedNumber}
                                                    onChange={handleCardNumberChange}
                                                    onFocus={handleInputFocus}
                                                    maxLength={19}
                                                    onBlur={handleCardNumberBlurCheck}
                                                    errorOccured={isCardNumberErr}
                                                    errorMeesage={'Enter valid card number'}
                                                />
                                            </div>
                                        </div>

                                        <div className='row mx-0 justify-content-between'>
                                            <div className='col-6 px-0 pe-2'>
                                                <InputField
                                                    labelName="MM/YY"
                                                    placeholderName={'MM/YY'}
                                                    type={'text'}
                                                    name={'expiryDate'}
                                                    value={cardInfo.expiryDate}
                                                    onChange={handleExpiryDateChange}
                                                    onFocus={handleInputFocus}
                                                    onBlur={handleCardExpBlurCheck}
                                                    errorOccured={isCardExpErr}
                                                    errorMeesage={'Enter valid exp. date'}
                                                />
                                            </div>

                                            <div className='col-6 px-0  ps-2'>
                                                <InputField
                                                    labelName="CVV"
                                                    placeholderName={'CVV'}
                                                    type={'text'}
                                                    name={'cvc'}
                                                    value={cardInfo.cvc}
                                                    onChange={handleCVCChange}
                                                    onFocus={handleInputFocus}
                                                    onBlur={handleCardCVCBlurCheck}
                                                    errorOccured={isCardCVCErr}
                                                    errorMeesage={'Enter valid cvc'}
                                                    maxLength={4}
                                                />
                                            </div>

                                        </div>




                                        <div className='row mx-0'>
                                            <div className='col-12 px-0'>
                                                <InputField
                                                    labelName="Name on card"
                                                    placeholderName={'Cardholder Name'}
                                                    type={'text'}
                                                    name={'cardHolder'}
                                                    value={cardInfo.cardHolder}
                                                    onChange={handleInputChange}
                                                    onFocus={handleInputFocus}
                                                    onBlur={handleCardHolderNameBlurCheck}
                                                    errorOccured={isCardHolderNameErr}
                                                    errorMeesage={'Enter valid cardholder name'}
                                                />
                                            </div>
                                        </div>








                                        <div className='row mx-0 justify-content-between mt-2'>


                                            <div className='col-12 px-0 mb-2'>
                                                <PrimaryButton
                                                    onClick={(e) => handleSubmit(e)}
                                                    buttonName={"Add new card"}
                                                    type={"submit"}
                                                    loadingMessage={"Loading..."}
                                                    isLoading={apiResponce}
                                                    style={{ width: "100%", background: 'green', border: 'none' }}
                                                />
                                            </div>

                                        </div>

                                    </form>
                                </> */}
                            </>



                        </div>
                    </div>

                </Modal.Body>
            </Modal>



            {
                handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />
            }
            {/* {apiResponce && <ResponceForAPI show={apiResponce} />} */}

            {
                updateCardTrigger &&
                <UpdateCardDetails
                    updateCardTrigger={updateCardTrigger}
                    handleCloseUpdateCard={handleCloseUpdateCard}
                    particularCard={particularCard}
                />
            }

            {
                addNewCardTrigger &&
                <AddNewCard
                    addNewCardTrigger={addNewCardTrigger}
                    handleCloseAddNewCard={handleCloseAddNewCard}
                />
            }

            {/* Subscription check */}
            <>
                <AcceptRejectModal
                    modalStatus={regCompanyConfirmationModalTrigger}
                    text={`Kindly register your company to gain access to this plan.`}
                    onClickReject={() => {
                        handleCloseRegCompanyConfirmationModalTrigger()
                    }}
                    onClickAccept={() => {
                        handleOpenRegisterComp()
                        handleCloseRegCompanyConfirmationModalTrigger()
                    }}
                    yesBtnTxt={`OKAY`}
                    noBtnTxt={"NO, GO BACK"}
                    isTwoActionsReq={true}
                />
            </>

            {companyModal &&
                <UserAddOwnCompany
                    companyModalStatus={companyModal}
                    setCompanyModalStatus={setCompanyModal}
                    handleClose={() => { handleCloseCompanyModal() }}
                    modalType={companyModalType}
                    companyID={companyId}
                    firstNameOwner={userName}
                    lastNameOwner={userLastName}
                    emailOwner={emailRedux}
                    phoneNumberOwner={phoneNumberRedux}
                    countryCodeOwner={phoneCodeRedux}
                />
            }
        </>
    );
};

export default Subscription;
